const StringResources = {
  English: {
    APP_TITLE: 'Enterprise',
    FOOTER_FFNII: 'Fujitsu Frontech Innovations Inc.',
    FOOTER_COPYRIGHT: `© Copyright ${new Date().getFullYear()}`,
    FOOTER_VERSION: `Version: ${process.env.REACT_APP_VERSION}`,
    TOOLTIP_LIGHT_MODE: 'Switch to light mode',
    TOOLTIP_DARK_MODE: 'Switch to dark mode',
    TOOLTIP_USER_ACCOUNT: 'User Account',
    TOOLTIP_SETTINGS: 'Settings',
    UPDATE_WGT_RECORD_TITLE: 'Update Weight Record',
    UPDATE_WGT_RECORD_ITEM_NAME: 'Name: ',
    UPDATE_WGT_RECORD_ITEM_BARCODE: 'Barcode: ',
    UPDATE_WGT_RECORD_WGTS: 'Weights',
    UPDATE_WGT_RECORD_STANDARD_WGT: 'Recommended weight: ',
    RECOMMENDED_WEIGHT: 'Recommended weight',
    ALERT_TYPE: 'Alert type',
    WEIGHT_CATEGORY: 'Weight category',
    UPDATE_WGT_RECORD_STANDARD_WGT_UNIT: 'clbs',
    DETAILS: 'Details',
    VIEW_DETAILS: 'View Details',
    ALERT_DETAILS: 'Alert Details',
    ITEM_DETAILS: 'Item details:',
    OPERATOR: 'Operator',
    WEIGHT_RECORD: 'Weight Record',
    SELECT_WEIGHT_CATEGORY: 'Select the supported Clean action to apply:',
    MIXED_WEIGHT_CATEGORY: 'Mixed weights',
    LIGHT_WEIGHT_CATEGORY: 'Light item',
    MEDIUM_WEIGHT_CATEGORY: 'Medium item',
    HEAVY_WEIGHT_CATEGORY: 'Heavy item',
    UPDATE_WGT_RECORD_STANDARD_SET_WGT: 'Set weight: ',
    UPDATE_WGT_RECORD_STANDARD_SET_FIXED_WGT: 'Fixed Weight',
    UPDATE_WGT_RECORD_ACTION_1: 'Apply',
    UPDATE_WGT_RECORD_ACTION_2: 'Cancel',
    WEIGHT_DELTA: 'Weight Delta',
    SET_THRESHOLD_TITLE: 'Set weight threshold',
    CLEAN_WEIGHT_RECORD: 'Clean Weight Record',
    REMOVE_ALL_WEIGHTS: 'Remove all weights',
    KEEP_LIGHT_WEIGHTS_ONLY: 'Keep only light weights (< 5 clbs)',
    KEEP_MEDIUM_WEIGHTS_ONLY:
      'Keep only medium weights (>: 5 clbs and <: 10 clbs)',
    KEEP_HEAVY_WEIGHTS_ONLY: 'Keep only heavy weights (> 10 clbs)',
    SET_THRESHOLD_ITEM_NAME: 'Item: ',
    SET_THRESHOLD_ITEM_BARCODE: 'Barcode: ',
    SET_THRESHOLD_WGTS: 'Weights',
    SET_THRESHOLD_STANDARD_WGT: 'Recommended threshold: ',
    SET_THRESHOLD_STANDARD_WGT_UNIT: 'clbs',
    SET_THRESHOLD_STANDARD_SET_WGT: 'Set threshold: ',
    SET_THRESHOLD_ACTION_1: 'Apply',
    SET_THRESHOLD_ACTION_2: 'Cancel',
    LAST_REFRESH_DATETIME: 'Last refreshed: ',
    LAST_HEARTBEAT_DATETIME: 'Last Heartbeat: ',
    TIMESTAMP: 'TimeStamp',
    REFRESH: 'Refresh',
    START_DATE_TIME: 'Date From: ',
    END_DATE_TIME: 'Date To: ',
    REPORT_DATE_RANGE_TOOLTIP: `This reflects the STORE's local date/time
    (regardless of time zone)`,
    FILTER_END_DATE_TIME: 'Use current date/time',
    REFRESH_RATE: 'Refresh Rate',
    REFRESH_DISABLED: 'Disabled',
    ONE_MINUTE: '1 minute',
    FIVE_MINUTES: '5 minutes',
    FIFTEEN_MINUTES: '15 minutes',
    THIRTY_MINUTES: '30 minutes',
    ONE_HOUR_STR: '1 hour',
    LOADING: 'Loading',
    SELECT_CATEGORY: 'Select Category: ',
    SELECT_NAME: 'Select Name: ',
    SELECT_COMMAND: 'Select Command',
    SELECT_TYPE: 'Select type',
    SELECT_STATUS: 'Select status',
    EXPORT_TO_EXCEL: 'Export to Excel',
    EXPORT_TO_PDF: 'Export to PDF',
    EXPORT_TO_CSV: 'Export to CSV',
    IMPORT_CSV: 'Import CSV',
    UPLOAD: 'Upload',
    INVALID_FILE_FORMAT: 'Invalid file format',
    REFERENCE_WEIGHTS: 'ReferenceWeights',
    REFERENCE_WEIGHTS_MANAGEMENT: 'Reference Weights Management',
    FAILED_TO_LOAD_THE_FILE: 'Failed to load the file',
    WEIGHTS: 'Weights',
    STORE: 'Store: ',
    STORES: 'Stores: ',
    STORE_SELECTED: 'store',
    STORES_SELECTED: 'stores',
    LANE: 'Lane: ',
    LANES: 'Lanes: ',
    LANE_SELECTED: 'lane',
    LANES_SELECTED: 'lanes',
    CASHIERS: 'Attendant Stations',
    MOBIILEATTENDANTS: 'Mobile Attendants',
    EXPORT_DATETIME: 'Export DateTime: ',
    READY_TO_UPLOAD: 'Ready to upload',
    IMPORT_SUCCESS_TEXT: 'Successfully imported the reference weights data',
    IMPORT_FAIL_TEXT: 'Failed to import the reference weights data',
    UPLOADING: 'Uploading',
    SELECT_ALL: 'Select All',
    UNSELECT_ALL: 'Unselect All',
    ASSETS_OVERVIEW: 'Assets Overview',
    ASSET_STATUS_OVERVIEW: 'Device Status Overview',
    LANES_BY_SYSTEM_TYPE: 'Lanes by system type',
    TOTAL: 'Total',
    CLUSTER: 'Cluster: ',
    DIVISION: 'Division: ',
    STATION_TYPE: 'Station Type: ',
    ASSETS: 'Assets: ',
    BACK: 'Back',
    COLUMN_TITLE_STORE: 'Store',
    COLUMN_TITLE_CLUSTER: 'Cluster',
    COLUMN_TITLE_LANE: 'Lane',
    COLUMN_TITLE_DIVISION: 'Division',
    COLUMN_TITLE_LANE_TYPE: 'Type',
    COLUMN_TITLE_LANE_ASSETS: 'Assets',
    COLUMN_TITLE_LANE_LAST_REFRESHED: 'Last Heartbeat',
    COLUMN_TITLE_LANE_UPDATED: 'Last Updated',
    COLUMN_TITLE_LANE_UPDATE_DATE: 'Update Date',
    COLUMN_TITLE_LANE_NAME: 'Name',
    COLUMN_TITLE_LANE_CATEGORY: 'Category',
    COLUMN_TITLE_LANE_SUB_CATEGORY: 'Sub Category',
    COLUMN_TITLE_LANE_VALUE: 'Value',
    COLUMN_TITLE_DESCRIPTION: 'Description',
    COLUMN_TITLE_MACHINE_NAME: 'Machine Name',
    COLUMN_TITLE_FREESPACE: 'Drive1 FreeSpace [MB]',
    COLUMN_TITLE_FREESPACE_2: 'Drive2 FreeSpace [MB]',
    COLUMN_TITLE_FAILURE: 'Failure',
    COLUMN_TITLE_CREATED_ON: 'Created On',
    COLUMN_TITLE_STATUS: 'Status',
    COLUMN_TITLE_ETA: 'ETA',
    COLUMN_TITLE_DIRECTORY: 'Directory',
    COLUMN_TITLE_FILENAME: 'File Name',
    COLUMN_TITLE_ACTIONS: 'Actions',
    COLUMN_TITLE_COMMANDS: 'Commands',
    COLUMN_TITLE_MANAGEMENT_ACTION: 'Registration Status',
    COLUMN_TITLE_COUNT: 'Count',
    COLUMN_TITLE_PART_NAME: 'Part Name',
    COLUMN_TITLE_PART_NUMBER: 'Replacement Part #',
    COLUMN_TITLE_SYSTEM_TYPE: 'System Type',
    COLUMN_TITLE_CONFIDENCE_INTERVAL: 'Confidence Interval',
    COLUMN_TITLE_FIRMWARE_VERSION: 'Firmware Version',
    COLUMN_TITLE_REGION_INFO: 'Region Info',
    COLUMN_TITLE_PRIORITY: 'Priority',
    TIME_TO_ERROR: 'Days to Error',
    PREDICTION_CONFIDENCE: 'Confidence interval [days]',
    COLUMN_TITLE_DEVICE_CATEGORY: 'Device Category',
    COLUMN_TITLE_DEVICE_MODEL: 'Device Model',
    COLUMN_TITLE_FIRMWARE_FILE: 'Firmware File',
    COLUMN_TITLE_NEW_FIRMWARE_FILE: 'New Firmware File',
    COLUMN_TITLE_FIRMWARE_CHECKSUM: 'File Checksum',
    COLUMN_TITLE_NEW_FIRMWARE_CHECKSUM: 'New File Checksum',
    COLUMN_TITLE_FIRMWARE_FILEPATH: 'File Path',
    COLUMN_TITLE_UPLOAD_NEW_FIRMWARE: 'Upload New Firmware',
    COLUMN_TITLE_FIRMWARE_IMPORT_DATE: 'Import Date',
    COLUMN_TITLE_CONFIRM_UPLOAD_NEW_FIRMWARE: 'Confirm Firmware Upload',
    COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE: 'Confirm Firmware Removal',
    COLUMN_TITLE_CONFIRM_UPLOAD_NEW_FIRMWARE_QUESTION:
      'Are you sure you want to upload new firmware?',
    COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE_QUESTION:
      'Are you sure you want to remove this firmware?',
    FIRMWARE_MENU_HEADER:
      'Firmware files uploaded here will automatically be downloaded and applied at the lanes',
    FIRMWARE_MENU_ADD_NEW_FIRMWARE: 'Add new Firmware',
    FIRMWARE_UPLOAD_CONFIRMATION_TITLE: 'Upload Firmware File',
    FIRMWARE_UPDATE_CONFIRMATION_TITLE: 'Update Firmware File',
    FIRMWARE_UPLOAD_CONFIRMATION_MESSAGE:
      'Do you want to upload the following new Firmware File(s)?',
    FIRMWARE_UPDATE_CONFIRMATION_MESSAGE:
      'Do you want to update the existing Firmware File?',
    MODULE: 'Module',
    ACTION_CATEGORY: 'Action',
    DEGRADATION_INFO: 'Degradation Info',
    CLOSE_TICKET: 'Close Ticket',
    VIEW: 'View',
    LAST_REFRESHED: 'Last Refreshed: ',
    NODE_ID: 'Node ID: ',
    DOWNLOAD_ASSETS: 'Export to CSV',
    RUN_QUERY: 'Run Query',
    INCLUDE_CLOSED_RECORDS: 'Include Closed Records',
    INCLUDE_DECOMMISSIONED_RECORDS: 'Include Decommissioned Lanes',
    COLLAPSE_GROUPS: 'Collapse Groups',
    EXPAND_GROUPS: 'Expand Groups',
    OVERVIEW_SECTION: 'Overview',
    SHOW_ALERTS_SUMMARY: 'Show Alerts overview',
    SHOW_ASSETS_SUMMARY: 'Show Assets overview',
    SHOW_DEVICE_STATUS_SUMMARY: 'Show Device Status overview',
    ALERTS_OVERVIEW: 'Alerts Overview',
    LANE_COUNT: 'System count: ',
    FETCH_ERROR_MESSAGE_ASSETS: 'Failed to fetch assets ',
    FETCH_ERROR_MESSAGE_ASSET_STATUSES: 'Failed to fetch device statuses ',
    FETCH_ERROR_MESSAGE_NODE_VERSION_INFO: 'Failed to fetch version info',
    FETCH_ERROR_MESSAGE_TICKETS: 'Failed to fetch tickets',
    FETCH_ERROR_MESSAGE_REPORTS: 'Failed to fetch reports',
    FETCH_PREVENTIVE_ERROR_MESSAGE_MAINTENANCE:
      'Failed to fetch preventive records',
    FETCH_PREDICTIVE_ERROR_MESSAGE_MAINTENANCE:
      'Failed to fetch predictive records',
    PING_ERROR_MESSAGE_MAINTENANCE: 'Failed to ping DMMTransferService',
    UPDATE_ERROR_MESSAGE_MAINTENANCE: 'Failed to update record',
    CLOSE_ERROR_MESSAGE_TICKETS: 'Failed to close ticket',
    NOTIFICATIONS_FETCH_ERROR: 'Failed to fetch notifications data',
    ONLINE: 'Online',
    OFFLINE: 'Offline',
    MANUFACTURER: 'Manufacturer',
    SERIAL_NUMBER: 'Serial Number',
    FIRMWARE_VERSION: 'FirmwareVersion',
    STATUS: 'Status',
    STATUS_HEADER: 'Status:',
    MODEL: 'Model',
    CURRENT_ISSUE: 'Current Issue',
    COMMAND_RESET_DEVICE: 'Reset Device',
    COMMAND_REBOOT_LANE: 'Reboot System',
    COMMAND_RESET_DEVICE_SENT_SUCCESS: 'Reset Device command sent successfully',
    CLOSE_TICKET_SENT_SUCCESS: 'Close Ticket command sent successfully',
    REPORTS: 'Report: ',
    REPORTS_GENERATED_ON: 'Generated: ',
    GENERATE_REPORT: 'Generate Report',
    COLUMN: 'Column',
    CATEGORY: 'Category: ',
    DATE_RANGE: 'Date Range: ',
    ITEM_SELECTED: 'selected',
    ITEMS_SELECTED: 'selected',
    OK_BUTTON: 'Ok',
    CANCEL_BUTTON: 'Cancel',
    START_DATE_ERRORMSG: 'Invalid start date',
    END_DATE_ERRORMSG: 'Invalid end date',
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_SEVEN_DAYS: 'Last 7 days',
    OTHER: 'Other...',
    START_DATE_LABEL: 'Start date',
    END_DATE_LABEL: 'End date',
    PAGE_TITLE_OVERVIEW: 'Overview',
    PAGE_TITLE_ALERTS: 'Alerts',
    PAGE_TITLE_DEVICES: 'Devices',
    PAGE_TITLE_ASSETS: 'Assets',
    PAGE_TITLE_PRODUCTS: 'Products',
    PAGE_TITLE_PRODUCTS_IMPORT: 'Import',
    PAGE_TITLE_PRODUCTS_HEALTH: 'Health',
    PAGE_TITLE_AI: 'AI',
    PAGE_TITLE_REPORTS: 'Reports',
    PAGE_TITLE_NBC: 'NBC',
    PAGE_TITLE_TICKETS: 'Tickets',
    PAGE_TITLE_HEALTH: 'Health',
    PAGE_TITLE_CONFIG: 'Config',
    PAGE_TITLE_NOTIFICATIONS: 'Notifications',
    PAGE_TITLE_NOTIFICATION_RULES: 'Notification Rules',
    PAGE_TITLE_USER_MANAGEMENT: 'User Management',
    PAGE_TITLE_HELP: 'Help',
    PAGE_TITLE_REGISTRATION: 'Registration',
    PAGE_TITLE_SIGNIN: 'Sign In',
    PAGE_TITLE_WORKINPROGRESS: 'Work In Progress',
    PAGE_TITLE_SETTINGS: 'Settings',
    PAGE_TITLE_VISION: 'Vision',
    FIELD_ASSETINFO_LABEL: 'Asset',
    FIELD_STORE_LABEL: 'Store',
    FIELD_CLUSTER_LABEL: 'Cluster',
    FIELD_LANE_LABEL: 'Lane',
    FIELD_DIVISION_LABEL: 'Division',
    FIELD_NODETYPE_LABEL: 'Type',
    FIELD_STATUS_LABEL: 'Status',
    FILED_PRIORITY_LABEL: 'Priority',
    FIELD_CATEGORY_LABEL: 'Category',
    FIELD_FAILURE_CODE_LABEL: 'Failure Code',
    FIELD_MAINTENANCE_TYPE_LABEL: 'Maintenance Type',
    VALUE_PLACEHOLDER: 'Value',
    NAME_PLACEHOLDER: 'Name',
    CATEGORY_PLACEHOLDER: 'Category',
    STORE_PLACEHOLDER: 'Select Store',
    DIVISION_PLACEHOLDER: 'Select Division',
    NODE_TYPE_PLACEHOLDER: 'Select Type',
    STATUS_PLACEHOLDER: 'Select Status',
    CLUSTER_PLACEHOLDER: 'Select Cluster',
    LANE_PLACEHOLDER: 'Select Lane',
    PRIORITY_PLACEHOLDER: 'Select Priority',
    MODEL_PLACEHOLDER: 'Select Model',
    MODULE_PLACEHOLDER: 'Select Module',
    PARTNAME_PLACEHOLDER: 'Select Partname',
    ACTION_PLACEHOLDER: 'Select Action',
    TYPE_PLACEHOLDER: 'Select Type',
    FAILURE_CODE_PLACEHOLDER: 'Select Failure Code',
    ITEM_TITLE: 'Item',
    ALERT_TYPE_TITLE: 'Alert Type',
    STORE_TITLE: 'Store',
    NODE_TYPE_TITLE: 'Node Type',
    STORE_FIRST_REPORTED_TITLE: 'Store (first reported)',
    CLUSTER_TITLE: 'Cluster',
    LANE_TITLE: 'Lane',
    STATUS_TITLE: 'Status',
    COMMANDS_TITLE: 'Commands',
    CREATED_ON_TITLE: 'Created On',
    BARCODE_TITLE: 'Barcode',
    ALERT_COUNT_TITLE: 'Alert Count',
    IN_PROGRESS_TITLE: 'In Progress',
    OPEN_TITLE: 'Open',
    CLOSED_TITLE: 'Closed',
    FROM_LABEL: 'From:',
    TO_LABEL: 'To:',
    SEARCH_PLACEHOLDER: 'Search...',
    LANGUAGE_LABEL: 'Language',
    PROFILE: 'Profile',
    SIGN_OUT: 'Sign Out',
    ENGLISH_OPTION: 'English',
    FRENCH_OPTION: 'French',
    USERNAME_PLACEHOLDER: 'User Name',
    PASSWORD_PLACEHOLDER: 'Password',
    LOGIN_ERROR_MSG: 'Incorrect user name or password',
    REMEMBER_ME_LABEL: 'Remember me',
    FORGOT_PASSWORD_LABEL: 'Forgot password?',
    CREATE_ACCOUNT_LABEL: 'Create Account',
    SIGN_UP: 'Sign up',
    FIRSTNAME_PLACEHOLDER: 'First Name',
    LASTNAME_PLACEHOLDER: 'Last Name',
    EMAIL_ADDRESS_PLACEHOLDER: 'Email Address',
    RECIEVE_VIA_EMAIL:
      'I wish to receive marketing promotions and updates by email.',
    ALL_READY_REGISTER: 'Already have an account? Sign in',
    MIXED_LIGHT_HEAVY_STR: 'Mixed light/heavy weights',
    MIXED_ZERO_HEAVY_STR: 'Mixed zero/heavy weights',
    WEIGHT_OVERRIDDEN_STR: 'Weight overridden',
    UNKNOWN_STR: 'Unknown',
    NONE_STR: 'None',
    NEW_STR: 'New',
    COMPLETED_STR: 'Completed',
    COMPLETED_WITH_ERROR: 'Completed (with errors)',
    EXECUTION_IN_PROGRESS: 'Execution In Progress',
    EXECUTION_COMPLETED: 'Execution Completed',
    EXECUTION_COMPLETED_WITH_ERRORS: 'Execution Completed (with errors)',
    EXECUTION_FAILED: 'Execution Failed',
    FAILED_STR: 'Failed',
    CANCELED_STR: 'Canceled',
    PENDING_STR: 'Pending',
    UPDATE_STR: 'Update',
    CLEAN_STR: 'Clean',
    SET_TO_DEFAULT_STR: 'Set to Default',
    SET_TRESHOLD: 'Set Threshold',
    CLOSE_STR: 'Close',
    APPLY_RECOMMENDED: 'Apply Recommended',
    OPEN_STR: 'Open',
    RESOLVED_STR: 'Resolved',
    CLOSED_STR: 'Closed',
    PREV_MAINT_REQUIRED: 'Preventive Maintenance',
    PRED_MAINT_REQUIRED: 'Predictive Maintenance',
    DAYS_LEFT: 'days left',
    DMM_CONFIRM_TITLE: 'Maintenance Update',
    DMM_CONFIRM_PROMPT:
      'Please confirm the following maintenance has been performed',
    YES: 'Yes',
    NO: 'No',
    DISPATCH_TECH: 'Dispatch Technician',
    DONE: 'Done',
    TECH_DISPATCH_REQUESTED: 'Dispatch Requested',
    TECH_DISPATCHED: 'Technician Dispatched',
    DONE_BY_TECH_ENTERPRISE: 'Done By Technician (Enterprise)',
    DONE_BY_TECH_DP: 'Done By Technician (DP)',
    DONE_AUTOMATICALLY: 'Done Automatically',
    CONFIRM_DISPATCH_TECH:
      'Request technician dispatch to perform this maintenance?',
    CURRENT_LOCALE: 'en-US',
    LOAD_MORE: 'Load more..',
    LANES_DOWN: 'Lanes down',
    DEVICE_ERRORS: 'Device errors',
    DEVICE_WARNINGS: 'Device warnings',
    DEVICE_ISSUES_BY_CATEGORY: 'Device issues by category',
    WARNING: 'Warning',
    ERROR: 'Error',
    NUMBER_OF_ISSUES: '# of issues',
    LANES_DOWN_PERCENTAGE: '% of total lanes',
    TOP_STORES_WITH_DEVICE_ISSUES: 'Top 5 stores with device issues',
    NUMBER_OF_DEVICE_ISSUES: '# of device issues',
    TOP_STORES_WITH_LANES_DOWN: 'Top 5 stores with lanes down',
    NUMBER_OF_LANES_DOWN: '# of lanes down',
    TOP_STORES_WITH_ALERTS: 'Top 5 stores with new alerts',
    NUMBER_OF_ALERTS: '# of alerts',
    NEW_ALERTS: 'New Alerts',
    OPEN_ALERTS_BY_TYPE: 'New alerts by type',
    NUMBER_OF_TICKETS: '# of tickets',
    TOP_STORES_WITH_TICKETS: 'Top 5 stores with tickets',
    OPEN_TICKETS_BY_DEVICE_CATEGORY: 'Tickets by device category',
    NUMBER_OF_OPEN_TICKETS: '# of open tickets',
    ALL: 'All',
    CLEAR: 'Clear',
    TOP_DEVICE_ISSUES: 'Top device issues',
    ERROR_STATE: 'Error State',
    SHOW_TICKETS_SUMMARY: 'Show Tickets overview',
    LANES_OFFLINE: 'Lanes not reporting',
    SOFTWARE_VERSION: 'Software versions',
    SHOW_HEALTH_SUMMARY: 'Show Health overview',
    PC: 'PC',
    STATUSES: 'Statuses',
    REPORTING: 'Reporting',
    NOT_REPORTING: 'Not Reporting',
    DECOMMISSIONED: 'Decommissioned',
    BUILD_NUMBER: 'Build Number',
    PACKAGE_NAME: 'Package Name',
    VERLESS_PACKAGE_NAME: 'Verless Package Name',
    ASM_ROLE: 'ASM Role',
    IMAGE_VERSION: 'Image Version',
    DELIVERY_CODE: 'Delivery Code',
    LANE_STATUS: 'Lane Status',
    REPORTING_THRESHOLD_DAYS: 'Reporting Threshold (days)',
    ARRANGEMENT: 'Overview order',
    ALERTS_SUMMARY: 'Alerts overview',
    ASSETS_SUMMARY: 'Assets overview',
    DEVICE_STATUS_SUMMARY: 'Device status overview',
    HEALTH_SUMMARY: 'Health overview',
    TICKETS_SUMMARY: 'Tickets overview',
    OPERATOR_CONTAINS: 'contains',
    OPERATOR_DOES_NOT_CONTAINS: 'does not contains',
    OPERATOR_EQUAL: 'is equal to',
    OPERATOR_IS_NOT_EQUAL: 'is not equal to',
    OPERATOR_IS_AFTER_OR_EQUAL_TO: 'is after or equal to',
    OPERATOR_IS_AFTER: 'is after',
    OPERATOR_IS_BEFORE: 'is before',
    OPERATOR_IS_BEFORE_OR_EQUAL_TO: 'is before or equal to',
    OPERATOR_STARTS_WITH: 'Starts with',
    OPERATOR_ENDS_WITH: 'Ends with',
    OPERATOR_IS_NULL: 'Is null',
    OPERATOR_IS_NOT_NULL: 'Is not null',
    OPERATOR_IS_EMPTY: 'Is empty',
    OPERATOR_IS_NOT_EMPTY: 'Is not empty',
    ACTIVE: 'Active',
    INITIAL_REGISTRATION: 'Initial Registration',
    TRANSFER_PENDING: 'Transfer Pending',
    TRANSFER_COMPLETED: 'Transfer Completed',
    TRANSFER_CANCELLED: 'Transfer Cancelled',
    REACTIVATED: 'Reactivated',
    REIMAGE_PENDING: 'Reimage Pending',
    REIMAGE_COMPLETED: 'Reimage Completed',
    REIMAGE_CANCELLED: 'Reimage Cancelled',
    REGISTRATION_SUCCESSFULL: 'Registration Successful',
    UNSCHEDULED_CHANGE: 'Unscheduled Change',
    COLUMN_TITLE_TIMEZONE: 'TimeZone',
    MENU_NAME_DEVICE_TRENDS: 'Trends',
    MENU_NAME_DEVICE_FIRMWARE: 'Firmware',
    PAGE_TITLE_DEVICE_FIRMWARE: 'Firmware',
    PAGE_TITLE_DEVICE_TRENDS: 'Device Trends',
    MENU_NAME_DEVICES_CURRENT: 'Statuses',
    MENU_NAME_ALERTS_CURRENT: 'Statuses',
    PAGE_TITLE_DEVICES_CURRENT: 'Current Device Statuses',
    PAGE_TITLE_ALERTS_CURRENT: 'Current Alert Statuses',
    PAGE_TITLE_MAINTENANCE: 'Maintenance',
    PAGE_TITLE_MAINTENANCE_PREV: 'Preventive',
    PAGE_TITLE_MAINTENANCE_PRED: 'Predictive',
    INPUT_ISSUE: 'Issue:',
    LAST_THIRTY_DAYS: 'Last 30 days',
    CURRENT: 'Current',
    SELECT_ISSUE: 'Select Issue:',
    SELECT_FILTERS_OPTIONAL: 'Select filters (Optional):',
    ISSUE: 'Issue: ',
    DEVICE_ISSUE_HISTORY: 'Device issue history',
    DATES: 'Dates',
    COUNTS: 'Counts',
    DATE: 'Date: ',
    PAGE_TITLE_COMMANDS: 'Commands',
    SELECT_DIVISION: 'Select Division(s):',
    SELECT_STORES: 'Select Store(s):',
    SELECT_CLUSTERS: 'Select Cluster(s):',
    SELECT_LANES: 'Select Lane(s):',
    SEND_BUTTON: 'Send',
    SELECT_COMMAND_DESTINATION: 'Select command destination(s):',
    COMMAND_SENT: 'command was sent',
    SET_ALL_WEIGHTS_TO_DEFAULT: 'Set All Weights to Default',
    SSO_SIGNIN_BUTTON: ' Go to Sign In ',
    SSO_SIGNIN_MESSAGE:
      'Click the button below to sign in with your organizational account:',
    SSO_SIGNIN_CANCEL_WARNING:
      'Login Cancelled. You have not been successfully logged in.',
    UPLOAD_FAILED: 'Upload failed',
    UPLOAD_COMPLETED: 'Upload Completed',
    UPLOADING_CSV: 'Uploading CSV',
    SAVING_REFERENCE_WEIGHTS: 'Saving reference weights',
    COMMAND_SEND_FAILED: 'Could not send command',
    TOTAL_COUNT: 'Total Count:',
    PAGE_TITLE_FEATURES: 'Features',
    SETTING: 'Setting',
    CONFIGURATION: 'Configuration',
    FETCH_ERROR_MESSAGE_CONFIG_SETTING: 'Failed to fetch config',
    SETTING_FILTER_NOT_EXISTED:
      'Setting filter not found (should contain at least one)',
    SETTING_FILTER_NOT_VALID:
      'Invalid setting filter (category and name need to be specified)',
    EDIT_CONFIG: 'Edit Config',
    PAGE_TITLE_ITEMS: 'Items',
    LOAD_ITEMS_BUTTON: 'Reload Items',
    COLUMN_TITLE_CODE: 'Code',
    COLUMN_TITLE_IMAGE: 'Image',
    COLUMN_TITLE_ENGLISH: 'English',
    COLUMN_TITLE_FRENCH: 'French',
    COLUMN_TITLE_SPANISH: 'Spanish',
    COLUMN_TITLE_QUANTITY_REQUIRED: 'Quantity Required',
    COLUMN_TITLE_WEIGHT_REQUIRED: 'Weight Required',
    COLUMN_TITLE_SPECIAL_SECURITY: 'Special Security',
    COLUMN_TITLE_ENABLED: 'Enabled',
    COLUMN_TITLE_VISIBLE: 'Visible',
    COLUMN_TITLE_HITS: 'Hits',
    COLUMN_TITLE_GROUPS: 'Groups',
    COLUMN_TITLE_PURCHASE_BY_DEPT: 'Purchase by Dept',
    COLUMN_TITLE_PRICE: 'Price',
    ADD_ITEM_TEXT: 'Add Item',
    APPLY_BUTTON: 'Apply',
    SETTING_NAME: 'Setting Name',
    NEW_VALUE: 'New Value',
    CURRENT_VALUE: 'Current Value',
    GROUP_LABEL: 'Group',
    CODE_PLACEHOLDER: 'e.g. 4011',
    PRICE_PLACEHOLDER: 'e.g. 30',
    ENGLISH_PLACEHOLDER: 'e.g. Banana',
    FRENCH_PLACEHOLDER: 'e.g. Banane',
    SPANISH_PLACEHOLDER: 'e.g. Banane',
    SAVE_BUTTON: 'Save',
    RADIO_BUTTON_YES: 'Yes',
    RADIO_BUTTON_NO: 'No',
    SELECT_GROUP: 'Select Group',
    APPLY_SNAPSHOT: 'Apply Snapshot',
    APPLY_SNAPSHOT_MODAL_TITLE: 'Apply NBC item snapshot',
    APPLY_NBC_SNAPSHOT: 'Apply NBC Snapshot',
    SELECT_LANES_TO_APPLY_CONFIGURATION:
      'Select lanes to apply this configuration',
    COMMAND_SENT_SUCCESSFULLY: 'Command sent successfully',
    NO_CATEGORIES_FOUND: 'No categories found',
    NO_ISSUES_FOUND_ON_THE_SELECTED_CATEGORY:
      'No issues found for the selected category',
    FAILED_TO_IMPORT_INCORRECT_FORMAT:
      'Failed to import CSV (incorrect format)',
    PAGE_TITLE_LOGS: 'Logs',
    PAGE_TITLE_HISTORICAL_LOGS: 'Historical',
    PAGE_TITLE_SCHEDULED_LOGS: 'Scheduled Logs',
    MENU_TITLE_SCHEDULED: 'Scheduled',
    REQUEST_LOGS: 'Request Logs',
    SCHEDULED_LOGS_HEADER:
      'Select the log files for the lanes to upload periodically',
    UPLOAD_LOGS: 'Select the lanes for which to upload logs',
    UPLOAD_LOGS_PERIODICALLY:
      'Select the lanes for which to upload logs periodically',
    COPY_TO_CLIPBOARD: 'Copied to clipboard',
    LOG_SERVER: 'Log Server',
    LOGS_REQUEST_HISTORY: 'Logs Request History',
    SCHEDULED_LOGS_REQUEST_HISTORY: 'Scheduled Logs Request History',
    COLUMN_REQUEST_DATE: 'Request Date',
    COLUMN_LOGS_START_DATE: 'Logs Start Date',
    COLUMN_LOGS_END_DATE: 'Logs End Date',
    EXPORT_TABLE_TO_CSV: 'Export Table to CSV',
    EXPORT_ASSETS_TO_CSV: 'Export Assets to CSV',
    COMMAND_REBOOT_DEVICE_SENT_SUCCESS:
      'Reboot System command sent successfully',
    SELECT_PROFILE: 'Select Profile',
    PROFILE_NAME: 'Profile Name:',
    ADD_PROFILE: 'Add Profile',
    EDIT_PROFILE: 'Edit Profile',
    DELETE_PROFILE: 'Delete Profile',
    MANAGE_PROFILES: 'Manage Profiles',
    PROFILE_NAME_PLACEHOLDER: 'Type your New Profile Name here',
    ERROR_LABEL: 'Profile name already exists',
    SELECT_NOTIFICATION_TYPE: 'Select Notification Type: ',
    REGISTERED_NOTIFICATIONS: 'Registered Notifications: ',
    NOTIFICATION_TYPE: 'Notification Type: ',
    CONTACT_NUMBER: 'Contact No.: ',
    REGISTER_USER_BUTTON: 'Register a User',
    EMAIL_STR: 'Email: ',
    TEXT_STR: 'Text',
    PHONE_NUMBER_STR: 'Phone Number: ',
    SINGLE_TICKET_CATEGORY: 'Send a Notification when a Ticket is created',
    MULTIPLE_TICKET_CATEGORY:
      'Send a Notification for every 50 Tickets created',
    NOTIFICATION_RULE_NAME: 'Rule Name: ',
    RULE_NAME_ERROR_MESSAGE: 'Please enter unique name',
    INVALID_USER_NAME_ERROR: 'Invalid username',
    USER_MANAGEMENT_BUTTON: 'User Management',
    REGISTERED_USERS: 'Registered Users',
    USER_DETAILS: 'User Details',
    USER_NAME: 'Username: ',
    USER_ID: 'User Id: ',
    USER_REGISTRATION_SUCCESS_MESSAGE: 'User Registered Successfully',
    USER_REGISTRATION_FAILED_MESSAGE: 'Failed to Register User',
    UNREGISTER_USER_TITLE: 'Unregister User',
    USER_UNREGISTER_CONFIRMATION_MESSAGE:
      'Are you sure you want to unregister this user?',
    USER_UNREGISTRATION_SUCCESS_MESSAGE: 'User Unregistered Successfully',
    USER_UNREGISTRATION_FAILED_MESSAGE: 'Failed to Unregister User',
    SELECT_USER: 'Select User(s): ',
    ADD_NOTIFICATION_RULE_BUTTON: 'Add Notification Rule',
    NOTIFICATION_REGISTRATION_SUCCESS_MESSAGE:
      'Notification Rule Registered Successfully',
    NOTIFICATION_REGISTRATION_FAILED_MESSAGE:
      'Failed to Register Notification Rule',
    UPDATE_SUCCESS_MESSAGE: 'User Details Updated Successfully',
    UPDATE_FAILED_MESSAGE: 'Failed to Update User Details',
    NOTIFICATION_UPDATE_SUCCESS_MESSAGE:
      'Notification Rule Updated Successfully',
    NOTIFICATION_UPDATE_FAILED_MESSAGE: 'Failed to Update Notification Rule',
    UNREGISTER_NOTIFICATION_TITLE: 'Unregister Notification',
    NOTIFICATION_UNREGISTER_CONFIRMATION_MESSAGE:
      'Are you sure you want to unregister this notification?',
    NOTIFICATION_UNREGISTRATION_SUCCESS_MESSAGE:
      'Notification Unregistered Successfully',
    NOTIFICATION_UNREGISTRATION_FAILED_MESSAGE:
      'Failed to Unregister Notification',
    LOW_STR: 'Low',
    MEDIUM_STR: 'Medium',
    HIGH_STR: 'High',
    CRITICAL_STR: 'Critical',
    DELETE_BUTTON: 'Delete',
    ADD_BUTTON: 'ADD',
    ADD_NEW_PROFILE: 'Add new profile',
    CONFIRM_MESSAGE: 'Are you sure you want to Delete this profile?',
    IMMEDIATE_STR: 'Immediate',
    DAILY_STR: 'Daily',
    WEEKLY_STR: 'Weekly',
    MONTHLY_STR: 'Monthly',
    SELECT_FREQUENCY: 'Select Frequency: ',
    SCHEDULE_TIME_STR: 'Schedule Time: ',
    SUNDAY: 'Sunday',
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SELECT_WEEK_DAY_STR: 'Select Day of Week',
    SELECT_MONTH_DAY_STR: 'Select Day of Month',
    MONTH_DAY_TOOLTIP:
      "Note: If the selected day exceeds the month's length, notifications will be sent on the last day of the month.",
    PAGE_TITLE_HISTORY: 'History',
    CONFIG_CHANGE_REQUEST_HISTORY: 'Configuration Change Request History',
    CONFIG_CHANGE_REQUEST: 'Configuration Change Request',
    ID: 'ID',
    SETTING_CHANGES: 'Setting Changes',
    FEATURE_CHANGES: 'Feature Changes',
    SELECTED_LANES: 'Selected Lanes',
    SETTINGS_GROUP: 'Settings Group',
    FEATURE: 'Feature',
    COMMAND: 'Command',
    LABEL_DATE: 'Date',
    FETCH_ERROR_MESSAGE_NBC: 'NBC error occurred',
    ITEM_CODE_ERROR_LABEL: 'Item Code already exists',
    IMPORT_CSV_DATA: 'Import CSV Data',
    ADD: 'Add items to existing profile',
    OVERWRITE: 'Overwrite existing profile',
    LAST_UPDATED: 'Last Updated',
    SELECT_NBC_IMPORT_METHOD: 'Please select the NBC item import method:',
    IMPORT_BUTTON: 'Import',
    CSV_IMPORT_TO_DB_ERROR_MESSAGE:
      'An error was encountered while importing CSV data into the database. Check reference weights service logs for details',
    UNABLE_TO_LOCATE_WEIGHT_REF_FOLDER_PATH:
      'Unable to locate reference weights folder path. Check reference weights service logs for details',
    CURRENT_REFERENCE_WEIGHTS: 'Current Reference Weights CSV',
    NO_FILE_UPLOADED: 'No File Uploaded',
    COMMANDS_HISTORY_LABEL: 'Set All Weights To Default command history',
    START_DATE_RANGE_LABEL: 'Start date:',
    END_DATE_RANGE_LABEL: 'End date:',
    FREQUENCY_LABEL: 'Frequency: ',
    CLOSE_COMMAND_MESSAGE: 'Successfully Closed Command',
    FAILED_TO_FETCH_COMMANDS: 'Failed to fetch commands',
    CLOSE_ON_TITLE: 'Closed On',
    MESSAGE_TITLE: 'Message',
    CLOSE_BUTTON: 'Close',
    SELECT_IMAGE: 'Select image',
    IMPORT_IMAGE: 'Import Images',
    IMPORT_MESSAGE: 'Successfully imported',
    ADDED_NBC_ITEM_MESSAGE: 'New NBC Item Added',
    UPDATE_NBC_ITEM_MESSAGE: 'NBC item updated',
    APPLY_SNAPSHOT_MODAL_MSG:
      'This NBC item snapshot will be applied at all lanes associated with profile',
    APPLY_SNAPSHOT_CONFIRM_MSG: 'Do you want to proceed?',
    ERROR_IMPORT_IMAGE: 'Invalid image format',
    ACCESS_CONTROL: 'Access Control',
    SELECT_CURRENT_ISSUE: 'Select CurrentIssue:',
    DECOMMISSION_NODE: 'Decommission',
    REACTIVATE_NODE: 'Reactivate',
    NODE_UPDATE_TITLE: 'Node Update',
    DECOMMISSION_CONFIRMATION_MESSAGE:
      'Please confirm you want to decommission this node:',
    REACTIVATE_CONFIRMATION_MESSAGE:
      'Please confirm you want to reactivate this node:',
    SELECT_REPORTS_FILTER: 'Select Reports Filter:',
    SELECT_REPORT_NAME: 'Select report name:',
    SEND_CSV_TO_LANE: 'Send CSV to lane(s)',
    CONFIG_ACCESS_CONTROL: 'Config Access Control',
    STORE_NUMBERS: 'Store Numbers',
    ACCESS_RIGHTS: 'Access Rights',
    BARCODE_EXPIRY: 'Barcode Expiry',
    PASSWORD_EXPIRY: 'Password Expiry',
    SEND_ACCESS_CONTROL_CSV_TO: 'Send Access Control CSV to:',
    IMPORT_CSV_LABEL: 'Import CSV here:',
    DELETE_EXISTING_USER_LABEL: 'Delete existing users?',
    PASSWORD_EXPIRE_LABEL: 'Passwords expire?',
    BARCODE_EXPIRE_LABEL: 'Barcodes expire?',
    NOTIFICATION_SUCCESSFULLY_DELETED_CONFIRMATION_MESSAGE:
      'Successfully deleted',
    CONFIRM_DETETE_MESSAGE:
      'Are you sure you want to delete the selected item(s)?',
    DELETE_ITEM_BUTTON: 'Delete Items',
    PAGE_TITLE_USERS: 'Users',
    ACCESS_CONTROL_HISTORY: 'Access Control History',
    APPLY_NOW: 'Apply [Now]',
    APPLY_SCHEDULE: 'Apply [Scheduled]',
    SNAPSHOT_SCHEDULED:
      'Please select when you would like to apply this snapshot:',
    SET_SCHEDULE: 'Set Schedule',
    INVALID_DATE_SCHEDULE: 'Invalid Date Schedule',
    APPLY_CHANGES_CONFIRMATION_MESSAGE:
      'Please select when you would like to apply this change:',
    AGE_DAYS: 'Age (Days)',
    PAGE_TITLE_DRILLDOWN: 'Drilldown',
    CREATE_DRILLDOWN_BUTTON: 'Create Drilldown',
    LABEL_IS_ENABLED: 'IsEnabled',
    LABEL_IS_VISIBLE: 'IsVisible',
    ADD_DRILLDOWN_BUTTON: 'Add New Drilldown',
    DELETE_DRILLDOWN_BUTTON: 'Delete Drilldown',
    ADD_FIRMWARE_FILE_SUCCESS_MESSAGE:
      'New Firmware File(s) uploaded successfully',
    ADD_FIRMWARE_FILE_FAILED_MESSAGE: 'Failed to add New Firmware File',
    UPDATE_FIRMWARE_FILE_SUCCESS_MESSAGE: 'Firmware File updated successfully',
    UPDATE_FIRMWARE_FILE_FAILED_MESSAGE:
      'Failed to Update (Firmware file may already exist)',
    DELETE_FIRMWARE_FILE_SUCCESS_MESSAGE: 'Firmware File deleted successfully',
    DELETE_FIRMWARE_FILE_FAILED_MESSAGE: 'Failed to delete Firmware File',
    ADD_ITEM_TO_DRILLDOWN_BUTTON: 'Add Item To Drilldown',
    EDIT_BUTTON: 'Edit',
    COLUMN_TITLE_DEPARTMENT: 'Department',
    COLUMN_TITLE_PLU: 'PLU',
    NOTIFICATION_MESSAGE: 'All items already exist; no new items were added',
    NBC_REQUEST_HISTORY: 'NBC Request History',
    EDIT_DRILLDOWN: 'Edit Drilldown',
    TIME_STR: 'Time:',
    ADD_NEW_STR: 'Add New',
    SEND_SCHEDULE_LOGS_STR: 'Send Request to Lanes',
    REMOVE_STR: 'Remove',
    INVALID_DIRECTORY_PATH: 'Invalid Directory Path',
    CANCEL_REQUEST: 'Cancel Request',
    CANCEL_ALL_REQUESTS: 'Cancel All Requests',
    LOG_FILES_STR: 'Log Files:',
    SEND_REQUEST_STR: 'Send Request',
    DRILLDOWN_SNAPSHOT_MODAL_TITLE: 'Apply Drilldown snapshot',
    SHOWING_ITEMS: 'Showing item(s): ',
    MANAGE_GROUPS: 'Manage Groups',
    ADD_NEW_GROUP: 'Add New Group',
    GROUP_NAME: 'Group Name',
    GROUP_ERROR_MSG: 'Group already exists',
    CONFIRM_DELETE_MESAGE: 'Are you sure you want to Delete this group?',
    NOT_SET_STR: 'Not set',
    EDIT_ITEM: 'Edit Item',
    START_DATE_TIME_COLUMN: 'Start Date Time',
    END_DATE_TIME_COLUMN: 'End Date Time',
    FILE_PATH: 'File Path',
    REPORT_ID: 'Report ID',
    VIEW_REPORT_STATUS: 'View Export History',
    REPORT_EXPORTS: 'Report Exports',
    PAGE_TITLE_SCHEDULED_IMPORTS: 'Scheduled Imports',
    SCHEDULED_ALERTS_HEADER: 'Schedule periodic import of Weights Database',
    SCHEDULED_ALERTS_HISTORY:
      'Scheduled Weight Database Import request history',
    ACCESS_CONTROL_PATH: 'Access Control Path',
    SCHEDULED_ACCESS_CONTROL_HEADER:
      'Schedule periodic import of Access Control Database',
    SCHEDULED_ACCESS_CONTROL_HISTORY:
      'Scheduled Access Control Database Import request history',
    PAGE_TITLE_SCHEDULED_ACCESS_CONTROL: 'Scheduled Access Control',
    STORES_COUNT: 'Stores (Count)',
    LANES_COUNT: 'Lanes (Count)',
    FILE_SIZE: 'File Size',
    FILE: 'File',
    DOWNLOAD: 'Download',
    INVALID_DOWNLOAD_URL: 'Invalid or expired download link',
    NO_MENU_ACCESS:
      'Access denied. You have successfully authenticated, but your account does not have permission to access this application. Please contact your administrator.',
    EDIT_BOUNDING_BOXES: 'Edit Bounding Boxes',
    DELETE_SELECTED_BOX: 'Delete Selected Box',
    BOUNDING_BOX_AREAS: 'Bounding Box Areas',
    BOUNDING_BOX_AREA_DESC:
      'Select a layer, then draw a rectangle on the image. Existing boxes can be dragged or resized',
    BOUNDING_BOX_OVERLAPS: 'overlaps with',
    EDIT_BOUNDING_BOX_MESSAGE: 'Edit from Lane Configuration View',
    IMPORT_PRODUCT_PACKAGES_TITLE: 'Import New Product Packages',
    VALIDATION_IN_PROGRESS: 'Validation in progress',
    VALIDATION_FAILED: 'Validation failed',
    UPLOAD_ARTIFACTS_CONFIRM_MESSAGE:
      'Do you want to upload the selected artifacts?',
    FILES_UPLOAD_LIST_MESSAGE: 'Files to be uploaded:',
    NO_FILES_TO_UPLOAD_MESSAGE:
      'The selected artifacts have already been uploaded. No new files are available for upload.',
    ACTIVATION_SUCCESS_MESSAGE: 'Successfully activated package',
    ACTIVATION_FAILED_MESSAGE: 'Failed to activate package',
    COLUMN_TITLE_PACKAGE_NAME: 'Package Name',
    COLUMN_TITLE_CURRENT_VERSION: 'Current Version',
    COLUMN_TITLE_AVAILABLE_VERSIONS: 'Available Versions',
    COLUMN_TITLE_FAILURE_MESSAGE: 'Failure Message',
    COLUMN_TITLE_PRODUCTS_HEALTH: 'Products Health',
    ACTIVATE: 'Activate',
    UPLOADING_STATUS: 'Uploading',
    COMPLETED_STATUS: 'Completed',
    FAILED_STATUS: 'Failed',
    VALIDATION_TITLE: 'Validation',
    PLEASE_WAIT: 'Please wait',
    HEALTHY: 'Healthy',
    PRODUCT_PACKAGES: 'Product Packages',
    IMPORTED_PACKAGES: 'Imported Packages',
    IMPORT_COMPLETED: 'Import completed',
    IMPORT_COMPLETED_WITH_ERRORS: 'Import completed (with errors)',
    IMPORT_FAILED: 'Import failed',
    IMPORTING_BATCH: 'Importing batch',
    OF: 'of',
    COMPLETE: 'Complete',
  },
  French: {
    APP_TITLE: 'Enterprise',
    FOOTER_FFNII: 'Fujitsu Frontech Innovations Inc.',
    FOOTER_COPYRIGHT: `© Droits d'auteur ${new Date().getFullYear()}`,
    FOOTER_VERSION: `Version: ${process.env.REACT_APP_VERSION}`,
    TOOLTIP_LIGHT_MODE: 'Mode lumineux',
    TOOLTIP_DARK_MODE: 'Mode sombre',
    TOOLTIP_USER_ACCOUNT: "Compte d'utilisateur",
    TOOLTIP_SETTINGS: 'Réglages',
    UPDATE_WGT_RECORD_TITLE: "Mettre à jour l'enregistrement de poids",
    UPDATE_WGT_RECORD_ITEM_NAME: 'Nom: ',
    UPDATE_WGT_RECORD_ITEM_BARCODE: 'Code à barre: ',
    UPDATE_WGT_RECORD_WGTS: 'Poids',
    UPDATE_WGT_RECORD_STANDARD_WGT: 'Poids recommandé: ',
    RECOMMENDED_WEIGHT: 'Poids recommandé',
    ALERT_TYPE: "Type d'alerte",
    WEIGHT_CATEGORY: 'Catégorie de poids',
    UPDATE_WGT_RECORD_STANDARD_WGT_UNIT: 'clbs',
    DETAILS: 'Détails',
    VIEW_DETAILS: 'Voir les détails',
    ALERT_DETAILS: 'Détails des alertes',
    ITEM_DETAILS: "Détails de l'article",
    OPERATOR: 'Opérateur',
    WEIGHT_RECORD: 'Poids',
    SELECT_WEIGHT_CATEGORY:
      "Sélectionnez l'action de nettoyage prise en charge à appliquer:",
    MIXED_WEIGHT_CATEGORY: 'Poids mixtes',
    LIGHT_WEIGHT_CATEGORY: 'Article léger',
    MEDIUM_WEIGHT_CATEGORY: 'Article moyen',
    HEAVY_WEIGHT_CATEGORY: 'Article lourd',
    UPDATE_WGT_RECORD_STANDARD_SET_WGT: 'Définir le poids: ',
    UPDATE_WGT_RECORD_STANDARD_SET_FIXED_WGT: 'Poids fixe',
    UPDATE_WGT_RECORD_ACTION_1: 'Appliquer',
    UPDATE_WGT_RECORD_ACTION_2: 'Annuler',
    WEIGHT_DELTA: 'Variation de poids',
    SET_THRESHOLD_TITLE: 'Définir le seuil de poids',
    CLEAN_WEIGHT_RECORD: 'Enregistrement de poids propre',
    REMOVE_ALL_WEIGHTS: 'Supprimer tous les poids',
    KEEP_LIGHT_WEIGHTS_ONLY: 'Ne gardez que des poids légers (< 5 clbs)',
    KEEP_MEDIUM_WEIGHTS_ONLY:
      'Ne gardez que des poids moyens (>: 5 clbs and <: 10 clbs)',
    KEEP_HEAVY_WEIGHTS_ONLY: 'Ne gardez que des poids lourds (> 10 clbs)',
    SET_THRESHOLD_ITEM_NAME: 'Article: ',
    SET_THRESHOLD_ITEM_BARCODE: 'Code à barre: ',
    SET_THRESHOLD_WGTS: 'Poids',
    SET_THRESHOLD_STANDARD_WGT: 'Seuil recommandé: ',
    SET_THRESHOLD_STANDARD_WGT_UNIT: 'clbs',
    SET_THRESHOLD_STANDARD_SET_WGT: 'Définir le seuil: ',
    SET_THRESHOLD_ACTION_1: 'Appliquer',
    SET_THRESHOLD_ACTION_2: 'Annuler',
    LAST_REFRESH_DATETIME: 'Dernière actualisation: ',
    LAST_HEARTBEAT_DATETIME: 'Dernière actualisation: ',
    TIMESTAMP: 'Horodatage',
    REFRESH: 'Rafraîchir',
    START_DATE_TIME: 'Date Début: ',
    END_DATE_TIME: 'Date Fin: ',
    REPORT_DATE_RANGE_TOOLTIP: `Cela reflète la date/heure locale du MAGASIN
    (quel que soit le fuseau horaire)`,
    FILTER_END_DATE_TIME: "Utiliser la date/l'heure actuelle",
    REFRESH_RATE: 'Fréquence de rafraîchissement',
    REFRESH_DISABLED: 'Désactivé',
    ONE_MINUTE: '1 minute',
    FIVE_MINUTES: '5 minutes',
    FIFTEEN_MINUTES: '15 minutes',
    THIRTY_MINUTES: '30 minutes',
    ONE_HOUR_STR: '1 heure',
    LOADING: 'Chargement',
    SELECT_CATEGORY: 'Sélectionner la catégorie: ',
    SELECT_NAME: 'Sélectionner le nom: ',
    SELECT_COMMAND: 'Sélectionner la commande',
    SELECT_TYPE: 'Sélectionner le type',
    SELECT_STATUS: 'Sélectionnez le statut',
    EXPORT_TO_EXCEL: 'Exporter vers Excel',
    EXPORT_TO_PDF: 'Exporter vers PDF',
    EXPORT_TO_CSV: 'Exporter vers CSV',
    IMPORT_CSV: 'Importer CSV',
    UPLOAD: 'Télécharger',
    INVALID_FILE_FORMAT: 'Format de fichier invalide',
    REFERENCE_WEIGHTS: 'Poids de référence',
    REFERENCE_WEIGHTS_MANAGEMENT: 'Gestion des poids de référence',
    FAILED_TO_LOAD_THE_FILE: 'Impossible de charger le fichier',
    WEIGHTS: 'Poids',
    STORE: 'Magasin: ',
    STORES: 'Magasins: ',
    STORE_SELECTED: 'magasin',
    STORES_SELECTED: 'magasins',
    LANE: 'Caisse: ',
    LANES: 'Caisses: ',
    LANE_SELECTED: 'caisse',
    LANES_SELECTED: 'caisses',
    CASHIERS: 'Postes de contrôle',
    MOBIILEATTENDANTS: 'Appareils mobiles',
    EXPORT_DATETIME: "Exporter la date et l'heure: ",
    READY_TO_UPLOAD: 'Prêt à télécharger',
    IMPORT_SUCCESS_TEXT:
      'Importation réussie des données de poids de référence',
    IMPORT_FAIL_TEXT:
      "Échec de l'importation des données de poids de référence",
    UPLOADING: 'Téléchargement',
    SELECT_ALL: 'Tout sélectionner',
    UNSELECT_ALL: 'Tout déselectionner',
    ASSETS_OVERVIEW: 'Aperçu des actifs',
    ASSET_STATUS_OVERVIEW: 'Aperçu des statuts',
    LANES_BY_SYSTEM_TYPE: 'Caisses par type de système',
    TOTAL: 'Totale',
    CLUSTER: 'Groupe: ',
    DIVISION: 'Division: ',
    STATION_TYPE: 'Type de poste: ',
    ASSETS: 'Actifs: ',
    BACK: 'Retour',
    COLUMN_TITLE_STORE: 'Magasin',
    COLUMN_TITLE_CLUSTER: 'Groupe',
    COLUMN_TITLE_LANE: 'Caisse',
    COLUMN_TITLE_DIVISION: 'Division',
    COLUMN_TITLE_LANE_TYPE: 'Type',
    COLUMN_TITLE_LANE_ASSETS: 'Actifs',
    COLUMN_TITLE_LANE_LAST_REFRESHED: 'Dernière actualisation',
    COLUMN_TITLE_LANE_UPDATED: 'Dernière actualisation',
    COLUMN_TITLE_LANE_UPDATE_DATE: 'Date de mise à jour',
    COLUMN_TITLE_LANE_NAME: 'Nom',
    COLUMN_TITLE_LANE_CATEGORY: 'Catégorie',
    COLUMN_TITLE_LANE_SUB_CATEGORY: 'Sous catégorie',
    COLUMN_TITLE_LANE_VALUE: 'Valeur',
    COLUMN_TITLE_DESCRIPTION: 'Description',
    COLUMN_TITLE_MACHINE_NAME: 'Nom de la machine',
    COLUMN_TITLE_FREESPACE: 'Espace libre disque1 (MO)',
    COLUMN_TITLE_FREESPACE_2: 'Espace libre disque2 (MO)',
    COLUMN_TITLE_FAILURE: 'Échec',
    COLUMN_TITLE_CREATED_ON: 'Date créé',
    COLUMN_TITLE_STATUS: 'Statut',
    COLUMN_TITLE_ETA: 'ETA',
    COLUMN_TITLE_DIRECTORY: 'Dossier',
    COLUMN_TITLE_FILENAME: 'Nom de fichier',
    COLUMN_TITLE_ACTIONS: 'Actions',
    COLUMN_TITLE_COMMANDS: 'Commandes',
    COLUMN_TITLE_MANAGEMENT_ACTION: `Statut d'inscription`,
    COLUMN_TITLE_COUNT: 'Compte',
    COLUMN_TITLE_PART_NAME: 'Pièce',
    COLUMN_TITLE_PART_NUMBER: '# de pièce de replacement',
    COLUMN_TITLE_SYSTEM_TYPE: 'Type de système',
    COLUMN_TITLE_CONFIDENCE_INTERVAL: 'Intervalle de confiance',
    COLUMN_TITLE_FIRMWARE_VERSION: 'Version du micrologiciel',
    COLUMN_TITLE_REGION_INFO: 'Région',
    COLUMN_TITLE_PRIORITY: 'Priorité',
    TIME_TO_ERROR: `Jours jusqu'à l'erreur`,
    PREDICTION_CONFIDENCE: 'Intervalle de confiance [jours]',
    COLUMN_TITLE_DEVICE_CATEGORY: "Catégorie d'appareil",
    COLUMN_TITLE_DEVICE_MODEL: "Modèle d'appareil",
    COLUMN_TITLE_FIRMWARE_FILE: 'Fichier du micrologiciel',
    COLUMN_TITLE_NEW_FIRMWARE_FILE: 'Nouveau fichier de micrologiciel',
    COLUMN_TITLE_FIRMWARE_CHECKSUM: 'Empreinte du fichier',
    COLUMN_TITLE_NEW_FIRMWARE_CHECKSUM: 'Nouvelle empreinte du fichier',
    COLUMN_TITLE_FIRMWARE_FILEPATH: 'Chemin du fichier',
    COLUMN_TITLE_FIRMWARE_IMPORT_DATE: "Date d'importation",
    COLUMN_TITLE_UPLOAD_NEW_FIRMWARE: 'Télécharger un nouveau micrologiciel',
    COLUMN_TITLE_CONFIRM_UPLOAD_NEW_FIRMWARE:
      'Confirmer le téléchargement du micrologiciel',
    COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE:
      'Confirmer la suppression du micrologiciel',
    COLUMN_TITLE_CONFIRM_UPLOAD_NEW_FIRMWARE_QUESTION:
      'Etes-vous sûr de vouloir télécharger un nouveau micrologiciel?',
    COLUMN_TITLE_REMOVE_UPLOAD_NEW_FIRMWARE_QUESTION:
      'Etes-vous sûr de vouloir supprimer ce micrologiciel?',
    FIRMWARE_MENU_HEADER:
      'Les fichiers de micrologiciel seront téléchargés et appliqués aux caisses',
    FIRMWARE_MENU_ADD_NEW_FIRMWARE: 'Ajouter nouveau micrologiciel',
    FIRMWARE_UPLOAD_CONFIRMATION_TITLE:
      'Télécharger le fichier du micrologiciel',
    FIRMWARE_UPDATE_CONFIRMATION_TITLE:
      'Mettre à jour le fichier du micrologiciel',
    FIRMWARE_UPLOAD_CONFIRMATION_MESSAGE:
      'Souhaitez-vous télécharger les nouveaux fichiers de micrologiciel suivants?',
    FIRMWARE_UPDATE_CONFIRMATION_MESSAGE:
      'Voulez-vous mettre à jour le fichier du micrologiciel existant?',
    MODULE: 'Module',
    ACTION_CATEGORY: `Action`,
    DEGRADATION_INFO: 'Informations sur la dégradation',
    CLOSE_TICKET: 'Fermer le billet',
    VIEW: 'Voir',
    LAST_REFRESHED: 'Dernière actualisation: ',
    NODE_ID: 'ID de la caisse: ',
    DOWNLOAD_ASSETS: 'Exporter vers CSV',
    RUN_QUERY: 'Exécuter la requête',
    INCLUDE_CLOSED_RECORDS: 'Inclure les enregistrements fermés',
    INCLUDE_DECOMMISSIONED_RECORDS: 'Inclure les caisses désactivées',
    COLLAPSE_GROUPS: 'Réduire les groupes',
    EXPAND_GROUPS: 'Élargir les groupes',
    OVERVIEW_SECTION: 'Aperçu',
    SHOW_ALERTS_SUMMARY: `Afficher l'aperçu des alertes`,
    SHOW_ASSETS_SUMMARY: `Afficher l'aperçu des actifs`,
    SHOW_DEVICE_STATUS_SUMMARY: `Afficher l'aperçu des dispositifs`,
    ALERTS_OVERVIEW: 'Aperçu des alertes',
    LANE_COUNT: 'Nombre de systèmes: ',
    FETCH_ERROR_MESSAGE_ASSETS: 'Échec de la récupération des actifs',
    FETCH_ERROR_MESSAGE_ASSET_STATUSES:
      'Échec de la récupération des états des appareils',
    FETCH_ERROR_MESSAGE_NODE_VERSION_INFO:
      'Échec de la récupération des informations de version',
    FETCH_ERROR_MESSAGE_TICKETS: 'Échec de la récupération des billets',
    FETCH_ERROR_MESSAGE_REPORTS: 'Échec de la récupération des rapports',
    FETCH_PREVENTIVE_ERROR_MESSAGE_MAINTENANCE: `Échec de la récupération d'entretiens préventifs`,
    FETCH_PREDICTIVE_ERROR_MESSAGE_MAINTENANCE: `Échec de la récupération d'entretiens prédictifs`,
    PING_ERROR_MESSAGE_MAINTENANCE: 'Échec de la requête du DMMTransferService',
    UPDATE_ERROR_MESSAGE_MAINTENANCE: `Échec de la mise à jour des entretiens`,
    CLOSE_ERROR_MESSAGE_TICKETS: 'Échec de la fermeture du ticket',
    NOTIFICATIONS_FETCH_ERROR:
      'Échec de la récupération des données de notifications',
    ONLINE: 'En ligne',
    OFFLINE: 'Hors ligne',
    MANUFACTURER: 'Fabricant',
    SERIAL_NUMBER: 'Numéro de série',
    FIRMWARE_VERSION: 'Version du micrologiciel',
    STATUS: 'Statut',
    STATUS_HEADER: 'Statut:',
    MODEL: 'Modèle',
    CURRENT_ISSUE: 'Problème actuel',
    COMMAND_RESET_DEVICE: 'Réinitialiser',
    COMMAND_REBOOT_LANE: 'Redémarrer le système',
    COMMAND_RESET_DEVICE_SENT_SUCCESS:
      'Commande de réinitialisation envoyée avec succès',
    CLOSE_TICKET_SENT_SUCCESS:
      'Commande de fermeture de billet envoyée avec succès',
    REPORTS: 'Rapport: ',
    REPORTS_GENERATED_ON: 'Date Généré: ',
    GENERATE_REPORT: 'Générer un rapport',
    COLUMN: 'Colonne',
    CATEGORY: 'Catégorie: ',
    DATE_RANGE: 'Plage de dates: ',
    ITEM_SELECTED: 'sélectionné',
    ITEMS_SELECTED: 'sélectionnés',
    OK_BUTTON: 'Ok',
    CANCEL_BUTTON: 'Annuler',
    START_DATE_ERRORMSG: 'Date de début invalide',
    END_DATE_ERRORMSG: 'Date de fin invalide',
    TODAY: "Aujourd'hui",
    YESTERDAY: 'Hier',
    LAST_SEVEN_DAYS: 'Les 7 derniers jours',
    OTHER: 'Autre...',
    START_DATE_LABEL: 'Date de début',
    END_DATE_LABEL: 'Date de fin',
    PAGE_TITLE_OVERVIEW: 'Aperçu',
    PAGE_TITLE_ALERTS: 'Alertes',
    PAGE_TITLE_DEVICES: 'Dispositifs',
    PAGE_TITLE_ASSETS: 'Actifs',
    PAGE_TITLE_PRODUCTS: 'Produits',
    PAGE_TITLE_PRODUCTS_IMPORT: 'Importer',
    PAGE_TITLE_PRODUCTS_HEALTH: 'Santé',
    PAGE_TITLE_AI: 'AI',
    PAGE_TITLE_REPORTS: 'Rapports',
    PAGE_TITLE_NBC: 'NBC',
    PAGE_TITLE_TICKETS: 'Billets',
    PAGE_TITLE_HEALTH: 'Santé',
    PAGE_TITLE_CONFIG: 'Config',
    PAGE_TITLE_NOTIFICATIONS: 'Notifications',
    PAGE_TITLE_NOTIFICATION_RULES: 'Règles de Notification',
    PAGE_TITLE_USER_MANAGEMENT: 'Gestion des Utilisateurs',
    PAGE_TITLE_HELP: 'Aide',
    PAGE_TITLE_REGISTRATION: 'Inscription',
    PAGE_TITLE_SIGNIN: "S'identifier",
    PAGE_TITLE_WORKINPROGRESS: 'Travail en cours',
    PAGE_TITLE_SETTINGS: 'Réglages',
    PAGE_TITLE_VISION: 'Vision',
    PAGE_TITLE_MAINTENANCE: 'Entretien',
    PAGE_TITLE_MAINTENANCE_PREV: 'Préventif',
    PAGE_TITLE_MAINTENANCE_PRED: 'Prédictive',
    FIELD_ASSETINFO_LABEL: 'Actif',
    FIELD_STORE_LABEL: 'Magasin',
    FIELD_CLUSTER_LABEL: 'Groupe',
    FIELD_LANE_LABEL: 'Caisse',
    FIELD_DIVISION_LABEL: 'Division',
    FIELD_NODETYPE_LABEL: 'Type',
    FIELD_STATUS_LABEL: 'Statut',
    FILED_PRIORITY_LABEL: 'Priorité',
    FIELD_CATEGORY_LABEL: 'Catégorie',
    FIELD_FAILURE_CODE_LABEL: "Code d'échec",
    FIELD_MAINTENANCE_TYPE_LABEL: "Type d'entretien",
    VALUE_PLACEHOLDER: 'Valeur',
    NAME_PLACEHOLDER: 'Nom',
    CATEGORY_PLACEHOLDER: 'Catégorie',
    STORE_PLACEHOLDER: 'Magasin',
    DIVISION_PLACEHOLDER: 'Division',
    CLUSTER_PLACEHOLDER: 'Groupe',
    LANE_PLACEHOLDER: 'Caisse',
    NODE_TYPE_PLACEHOLDER: 'Type',
    STATUS_PLACEHOLDER: 'Statut',
    PRIORITY_PLACEHOLDER: 'Priorité',
    MODEL_PLACEHOLDER: 'Modèle',
    MODULE_PLACEHOLDER: 'Module',
    PARTNAME_PLACEHOLDER: 'Nom de la pièce',
    ACTION_PLACEHOLDER: 'Action',
    FAILURE_CODE_PLACEHOLDER: "Code d'échec",
    TYPE_PLACEHOLDER: 'Type',
    ITEM_TITLE: 'Article',
    ALERT_TYPE_TITLE: "Type d'alerte",
    STORE_TITLE: 'Magasin',
    NODE_TYPE_TITLE: 'Type de la caisse',
    STORE_FIRST_REPORTED_TITLE: 'Magasin (1ère instance)',
    CLUSTER_TITLE: 'Groupe',
    LANE_TITLE: 'Caisse',
    STATUS_TITLE: 'Statut',
    COMMANDS_TITLE: 'Commandes',
    CREATED_ON_TITLE: 'Date créé',
    BARCODE_TITLE: 'Code à barre',
    ALERT_COUNT_TITLE: "Compte d'alertes",
    IN_PROGRESS_TITLE: 'En cours',
    OPEN_TITLE: 'Ouvertes',
    CLOSED_TITLE: 'Fermées',
    FROM_LABEL: 'De:',
    TO_LABEL: 'À:',
    SEARCH_PLACEHOLDER: 'Chercher...',
    LANGUAGE_LABEL: 'Langue',
    PROFILE: 'Profil',
    SIGN_OUT: 'Déconnexion',
    ENGLISH_OPTION: 'Anglais',
    FRENCH_OPTION: 'Français',
    USERNAME_PLACEHOLDER: "Nom d'utilisateur",
    PASSWORD_PLACEHOLDER: 'Mot de passe',
    LOGIN_ERROR_MSG: 'Identifiant ou mot de passe incorrect',
    REMEMBER_ME_LABEL: 'Souvenez-moi',
    FORGOT_PASSWORD_LABEL: 'Mot de passe oublié?',
    CREATE_ACCOUNT_LABEL: 'Créer un compte',
    SIGN_UP: "S'inscrire",
    FIRSTNAME_PLACEHOLDER: 'Prénom',
    LASTNAME_PLACEHOLDER: 'Nom de famille',
    EMAIL_ADDRESS_PLACEHOLDER: 'Adresse courriel',
    RECIEVE_VIA_EMAIL:
      'Je souhaite recevoir des promotions marketing et des mises à jour par courriel.',
    ALL_READY_REGISTER: "Vous avez déjà un compte? S'identifier",
    MIXED_LIGHT_HEAVY_STR: 'Poids légers/lourds mixtes',
    MIXED_ZERO_HEAVY_STR: 'Poids nuls/lourds mixtes',
    WEIGHT_OVERRIDDEN_STR: 'Poids remplacé',
    UNKNOWN_STR: 'Inconnu',
    NONE_STR: 'Aucun',
    NEW_STR: 'Nouveau',
    COMPLETED_STR: 'Complété',
    COMPLETED_WITH_ERROR: 'Complété (avec erreurs)',
    EXECUTION_IN_PROGRESS: 'Exécution en cours',
    EXECUTION_COMPLETED: 'Exécution complété',
    EXECUTION_COMPLETED_WITH_ERRORS: 'Exécution complété (avec erreurs)',
    EXECUTION_FAILED: 'Échec de l’exécution',
    FAILED_STR: 'Echoué',
    CANCELED_STR: 'Annulé',
    PENDING_STR: 'En attente',
    UPDATE_STR: 'Mise à jour',
    CLEAN_STR: 'Nettoyer',
    SET_TO_DEFAULT_STR: 'Réinitialiser',
    SET_TRESHOLD: 'Définir le seuil',
    CLOSE_STR: 'Fermer',
    APPLY_RECOMMENDED: 'Appliquer command recommandée',
    OPEN_STR: 'Ouvert',
    RESOLVED_STR: 'Résolu',
    CLOSED_STR: 'Fermée',
    PREV_MAINT_REQUIRED: 'Entretien préventif',
    PRED_MAINT_REQUIRED: 'Entretien prédictive',
    DAYS_LEFT: 'jours restants',
    DMM_CONFIRM_TITLE: `Mise à jour de l'entretien`,
    DMM_CONFIRM_PROMPT: `Veuillez confirmer que l'entretien suivant a été effectué`,
    YES: 'Oui',
    NO: 'Non',
    DISPATCH_TECH: 'Envoyez un(e) technicien(ne)',
    DONE: 'Fini',
    TECH_DISPATCH_REQUESTED: 'Technicien(ne) demandé(e)',
    TECH_DISPATCHED: 'Technicien(ne) en route',
    DONE_BY_TECH_ENTERPRISE: 'Réalisé par un technicien (entreprise)',
    DONE_BY_TECH_DP: 'Réalisé par un technicien (DP)',
    DONE_AUTOMATICALLY: 'Fait automatiquement',
    CONFIRM_DISPATCH_TECH: `Demander l'envoi d'un(e) technicien(ne) pour effectuer cet entretien?`,
    CURRENT_LOCALE: 'fr-CA',
    LOAD_MORE: 'Charger plus..',
    LANES_DOWN: 'Caisses hors service',
    DEVICE_ERRORS: 'Erreurs de dispositifs',
    DEVICE_WARNINGS: 'Avert. de dispositifs',
    DEVICE_ISSUES_BY_CATEGORY: 'Problèmes de dispositifs par catégorie',
    WARNING: 'Avertissement',
    ERROR: 'Erreur',
    NUMBER_OF_ISSUES: '# de problèmes',
    LANES_DOWN_PERCENTAGE: '% du total des caisses',
    TOP_STORES_WITH_DEVICE_ISSUES:
      'Principaux 5 magasins avec des problèmes de dispositifs',
    NUMBER_OF_DEVICE_ISSUES: 'Nombre de problèmes de dispositifs',
    TOP_STORES_WITH_LANES_DOWN:
      'Principaux 5 magasins avec des caisses hors service',
    NUMBER_OF_LANES_DOWN: '# de caisses hors service',
    TOP_STORES_WITH_ALERTS: 'Principaux 5 magasins avec nouvelles alertes',
    NUMBER_OF_ALERTS: "# d'alertes",
    NEW_ALERTS: 'Nouvelles alertes',
    OPEN_ALERTS_BY_TYPE: 'Nouvelles alertes par type',
    NUMBER_OF_TICKETS: '# de billets',
    TOP_STORES_WITH_TICKETS: 'Principaux 5 magasins avec des billets',
    OPEN_TICKETS_BY_DEVICE_CATEGORY: 'Billets par catégorie de dispositif',
    NUMBER_OF_OPEN_TICKETS: '# de billets ouverts',
    ALL: 'Tout',
    CLEAR: 'Effacer',
    TOP_DEVICE_ISSUES: 'Principaux problèmes de dispositifs',
    ERROR_STATE: "État d'erreur",
    SHOW_TICKETS_SUMMARY: `Afficher l'aperçu des billets`,
    LANES_OFFLINE: 'Caisses hors ligne',
    SOFTWARE_VERSION: 'Versions du logiciel',
    SHOW_HEALTH_SUMMARY: `Afficher l'aperçu de la santé`,
    PC: 'PC',
    STATUSES: 'Statuts',
    REPORTING: 'En ligne',
    NOT_REPORTING: 'Hors ligne',
    DECOMMISSIONED: 'Désactivé',
    BUILD_NUMBER: 'Numéro de construction',
    PACKAGE_NAME: 'Nom du paquet',
    VERLESS_PACKAGE_NAME: 'Nom du paquet Verless',
    ASM_ROLE: 'Rôle ASM',
    IMAGE_VERSION: `Version de l'image`,
    DELIVERY_CODE: 'Code de livraison',
    LANE_STATUS: 'Statut de caisse',
    REPORTING_THRESHOLD_DAYS: 'Seuil hors ligne (jours)',
    ARRANGEMENT: 'Ordre des aperçus',
    ALERTS_SUMMARY: 'Aperçu des alertes',
    ASSETS_SUMMARY: 'Aperçu des actifs',
    DEVICE_STATUS_SUMMARY: 'Aperçu des dispositifs',
    HEALTH_SUMMARY: 'Aperçu de la santé',
    TICKETS_SUMMARY: 'Aperçu des billets',
    OPERATOR_CONTAINS: 'contient',
    OPERATOR_DOES_NOT_CONTAINS: 'ne contient pas',
    OPERATOR_EQUAL: 'est égal à',
    OPERATOR_IS_NOT_EQUAL: "n'est pas égal à",
    OPERATOR_IS_AFTER_OR_EQUAL_TO: 'est supérieur ou égal à',
    OPERATOR_IS_AFTER: 'est après',
    OPERATOR_IS_BEFORE: 'est avant',
    OPERATOR_IS_BEFORE_OR_EQUAL_TO: 'est avant ou égal à',
    OPERATOR_STARTS_WITH: 'Commence par',
    OPERATOR_ENDS_WITH: 'Se termine par',
    OPERATOR_IS_NULL: 'Est nul',
    OPERATOR_IS_NOT_NULL: "N'est pas nul",
    OPERATOR_IS_EMPTY: 'Est vide',
    OPERATOR_IS_NOT_EMPTY: "N'est pas vide",
    ACTIVE: 'Actif',
    INITIAL_REGISTRATION: 'Inscription initiale',
    TRANSFER_PENDING: 'Transfert en attente',
    TRANSFER_COMPLETED: 'Transfert terminé',
    TRANSFER_CANCELLED: 'Transfert annulé',
    REACTIVATED: 'Réactivé',
    REIMAGE_PENDING: 'Réimage en attente',
    REIMAGE_COMPLETED: 'Réimage terminée',
    REIMAGE_CANCELLED: 'Réimage annulé',
    REGISTRATION_SUCCESSFULL: 'Inscription réussie',
    UNSCHEDULED_CHANGE: 'Modification non planifiée',
    COLUMN_TITLE_TIMEZONE: 'Fuseau horaire',
    MENU_NAME_DEVICE_TRENDS: 'Historique',
    PAGE_TITLE_DEVICE_TRENDS: 'Historique des dispositifs',
    MENU_NAME_DEVICES_CURRENT: 'Statuts',
    MENU_NAME_DEVICE_FIRMWARE: 'Micrologiciel',
    PAGE_TITLE_DEVICE_FIRMWARE: 'Micrologiciel',
    MENU_NAME_ALERTS_CURRENT: 'Statuts',
    PAGE_TITLE_DEVICES_CURRENT: 'Statuts actuels des dispositifs',
    PAGE_TITLE_ALERTS_CURRENT: 'Statuts actuels des alertes',
    INPUT_ISSUE: 'Problème:',
    LAST_THIRTY_DAYS: 'Les 30 derniers jours',
    CURRENT: 'Actuel',
    SELECT_ISSUE: 'Sélectionnez le problème:',
    SELECT_FILTERS_OPTIONAL: 'Sélectionnez les filtres (facultatif):',
    ISSUE: 'Problème: ',
    DEVICE_ISSUE_HISTORY: "Historique des problèmes de l'appareil",
    DATES: 'Dates',
    COUNTS: 'Comptes',
    DATE: 'Date: ',
    PAGE_TITLE_COMMANDS: 'Commandes',
    SELECT_DIVISION: 'Sélectionnez les divisions:',
    SELECT_STORES: 'Sélectionnez les magasins:',
    SELECT_CLUSTERS: 'Sélectionnez les groupes:',
    SELECT_LANES: 'Sélectionnez les caisses:',
    SEND_BUTTON: 'Envoyer',
    SELECT_COMMAND_DESTINATION:
      'Sélectionnez la ou les destinations pour cette commande:',
    COMMAND_SENT: 'La commande a été envoyée',
    SET_ALL_WEIGHTS_TO_DEFAULT: 'Réinitialiser tous les poids',
    SSO_SIGNIN_BUTTON: 'Se connecter',
    SSO_SIGNIN_MESSAGE:
      'Appuyez sur le bouton ci-dessous pour vous connecter avec votre compte organisationnel',
    SSO_SIGNIN_CANCEL_WARNING: 'Connexion annulée',
    UPLOAD_FAILED: 'Échec du téléchargement',
    UPLOAD_COMPLETED: 'Téléchargement terminé',
    UPLOADING_CSV: 'Téléchargement du fichier CSV',
    SAVING_REFERENCE_WEIGHTS: 'Sauvegarde des poids de référence',
    COMMAND_SEND_FAILED: 'Impossible d’envoyer la commande',
    TOTAL_COUNT: 'Compte total:',
    PAGE_TITLE_FEATURES: 'Fonctionnalités',
    SETTING: 'Réglage',
    CONFIGURATION: 'Configuration',
    FETCH_ERROR_MESSAGE_CONFIG_SETTING:
      'Échec de la récupération de la configuration',
    SETTING_FILTER_NOT_EXISTED:
      'Filtre de réglage non défini (doit en contenir au moins un réglage )',
    SETTING_FILTER_NOT_VALID:
      'Filtre de réglage invalide (une catégorie et un nom doivent être définis)',
    EDIT_CONFIG: 'Modifier la configuration',
    PAGE_TITLE_ITEMS: 'Articles',
    LOAD_ITEMS_BUTTON: 'Recharger les éléments',
    COLUMN_TITLE_CODE: 'Code',
    COLUMN_TITLE_IMAGE: 'Image',
    COLUMN_TITLE_ENGLISH: 'Anglais',
    COLUMN_TITLE_FRENCH: 'Français',
    COLUMN_TITLE_SPANISH: 'Espagnol',
    COLUMN_TITLE_QUANTITY_REQUIRED: 'Quantité requise',
    COLUMN_TITLE_WEIGHT_REQUIRED: 'Poids requis',
    COLUMN_TITLE_SPECIAL_SECURITY: 'Sécurité spéciale',
    COLUMN_TITLE_ENABLED: 'Activé',
    COLUMN_TITLE_VISIBLE: 'Visible',
    COLUMN_TITLE_HITS: 'Comptes',
    COLUMN_TITLE_GROUPS: 'Groupes',
    COLUMN_TITLE_PURCHASE_BY_DEPT: 'Achat par département',
    COLUMN_TITLE_PRICE: 'Prix',
    ADD_ITEM_TEXT: 'Ajouter un article',
    APPLY_BUTTON: 'Appliquer',
    SETTING_NAME: 'Nom du paramètre',
    NEW_VALUE: 'Nouvelle valeur',
    CURRENT_VALUE: 'Valeur actuelle',
    CODE_LABEL: 'Code',
    PRICE_LABEL: 'Prix',
    GROUP_LABEL: 'Groupe',
    ENGLISH_LABEL: 'Anglais',
    FRENCH_LABEL: 'Français',
    SPANISH_LABEL: 'Espagnol',
    CODE_PLACEHOLDER: 'ex. 4011',
    PRICE_PLACEHOLDER: 'ex. 30',
    ENGLISH_PLACEHOLDER: 'ex. Banana',
    FRENCH_PLACEHOLDER: 'ex. Banane',
    SPANISH_PLACEHOLDER: 'ex. Banana',
    QUANTITY_REQUIRED_LABEL: 'Quantité requise',
    WEIGHT_REQUIRED_LABEL: 'Poids requis',
    SPECIAL_SECURITY_LABEL: 'Quantité requise',
    ENABLED_LABEL: 'Activé',
    VISIBLE_LABEL: 'Visible',
    PURCHASED_BY_DEPT_LABEL: 'Acheter par département',
    SAVE_BUTTON: 'Sauvegarder',
    RADIO_BUTTON_YES: 'Oui',
    RADIO_BUTTON_NO: 'Non',
    SELECT_GROUP: 'Sélectionner un Groupe',
    APPLY_SNAPSHOT: 'Appliquer NBC',
    APPLY_SNAPSHOT_MODAL_TITLE: 'Appliquer les articles NBC',
    SELECT_LANES_TO_APPLY_CONFIGURATION:
      'Sélectionnez les voies pour appliquer cette configuration',
    COMMAND_SENT_SUCCESSFULLY: 'Commande envoyée avec succès',
    NO_CATEGORIES_FOUND: 'Aucune catégorie trouvée',
    NO_ISSUES_FOUND_ON_THE_SELECTED_CATEGORY:
      'Aucun problème trouvé pour la catégorie sélectionnée',
    FAILED_TO_IMPORT_INCORRECT_FORMAT:
      "Échec d'importation du fichier CSV (format incorrect)",
    PAGE_TITLE_LOGS: 'Traces',
    PAGE_TITLE_HISTORICAL_LOGS: 'Historique',
    PAGE_TITLE_SCHEDULED_LOGS: 'Télécharger les traces périodiquement',
    MENU_TITLE_SCHEDULED: 'Planifiée',
    REQUEST_LOGS: 'Télécharger les traces',
    SCHEDULED_LOGS_HEADER:
      'Sélectionnez les fichiers traces des caisses à télécharger périodiquement',
    UPLOAD_LOGS:
      'Sélectionner les caisses pour lesquelles télécharger les traces',
    UPLOAD_LOGS_PERIODICALLY:
      'Sélectionner les caisses pour lesquelles télécharger les traces périodiquement',
    COPY_TO_CLIPBOARD: 'Copié dans le presse-papier',
    LOG_SERVER: 'Serveur de traces',
    LOGS_REQUEST_HISTORY: 'Historique des demandes de traces',
    SCHEDULED_LOGS_REQUEST_HISTORY:
      'Historique des demandes de traces planifiés',
    COLUMN_REQUEST_DATE: 'Date de la demande',
    COLUMN_LOGS_START_DATE: 'Date de début des traces',
    COLUMN_LOGS_END_DATE: 'Date de fin des traces',
    EXPORT_TABLE_TO_CSV: 'Exporter le tableau vers CSV',
    EXPORT_ASSETS_TO_CSV: 'Exporter les actifs vers CSV',
    COMMAND_REBOOT_DEVICE_SENT_SUCCESS:
      'La commande pour redémarrer le système a été envoyée avec succès',
    SELECT_PROFILE: 'Sélectionner un profil',
    ADD_PROFILE: 'Ajouter un profil',
    EDIT_PROFILE: 'Modifier le profil',
    DELETE_PROFILE: 'Supprimer le profil',
    MANAGE_PROFILES: 'Gérer le profils',
    DELETE_BUTTON: 'Supprimer',
    PROFILE_NAME_PLACEHOLDER: 'Tapez le nom de votre nouveau profil ici',
    ERROR_LABEL: 'Ce profil existe déjà',
    SELECT_NOTIFICATION_TYPE: 'Sélectionnez type de Notification: ',
    REGISTERED_NOTIFICATIONS: 'Notifications enregistrés: ',
    NOTIFICATION_TYPE: 'Type de Notification: ',
    CONTACT_NUMBER: 'Numéro de contact: ',
    REGISTER_USER_BUTTON: 'Enregistrer un utilisateur',
    EMAIL_STR: 'Email: ',
    TEXT_STR: 'Text',
    PHONE_NUMBER_STR: 'Numéro de Téléphone: ',
    SINGLE_TICKET_CATEGORY:
      "Envoyer une notification lorsqu'un ticket est créé",
    MULTIPLE_TICKET_CATEGORY:
      'Envoyer une notification tous les 50 tickets créés',
    NOTIFICATION_RULE_NAME: 'Nom de la règle: ',
    RULE_NAME_ERROR_MESSAGE: 'Veuillez entrer un nom unique',
    INVALID_USER_NAME_ERROR: "Nom d'utilisateur invalide",
    USER_MANAGEMENT_BUTTON: 'Gestion des Utilisateurs',
    REGISTERED_USERS: 'Utilisateurs Enregistrés',
    USER_DETAILS: "Détails de l'Utilisateur",
    USER_NAME: 'Username: ',
    USER_ID: "ID de l'utilisateur",
    REGISTRATION_SUCCESS_MESSAGE: 'Utilisateur enregistré avec succès',
    REGISTRATION_FAILED_MESSAGE: "Échec de l'enregistrement de l'utilisateur",
    UNREGISTER_USER_TITLE: 'Désinscrire un Utilisateur',
    UNREGISTER_CONFIRMATION_MESSAGE:
      'Etes-vous sûr de vouloir désinscrire cet utilisateur?',
    UNREGISTRATION_SUCCESS_MESSAGE: 'Utilisateur désinscrit avec succès',
    UNREGISTRATION_FAILED_MESSAGE:
      "Échec de la désinscription de l'utilisateur",
    SELECT_USER: 'Sélectionner un Utilisateur(s): ',
    ADD_NOTIFICATION_RULE_BUTTON: 'Ajouter une Règle de Notification',
    NOTIFICATION_REGISTRATION_SUCCESS_MESSAGE:
      'Règle de Notification Enregistrée avec Succès',
    NOTIFICATION_REGISTRATION_FAILED_MESSAGE:
      "Échec de l'enregistrement de la Règle de Notification",
    UPDATE_SUCCESS_MESSAGE:
      "Les détails de l'utilisateur ont été mis à jour avec succès",
    UPDATE_FAILED_MESSAGE:
      "Échec de la mise à jour des détails de l'utilisateur",
    NOTIFICATION_UPDATE_SUCCESS_MESSAGE:
      'La règle de notification a été mise à jour avec succès',
    NOTIFICATION_UPDATE_FAILED_MESSAGE:
      'Échec de la mise à jour de la règle de notification',
    UNREGISTER_NOTIFICATION_TITLE: 'Notification de désinscription',
    NOTIFICATION_UNREGISTER_CONFIRMATION_MESSAGE:
      'Etes-vous sûr de vouloir désenregistrer cette notification?',
    NOTIFICATION_UNREGISTRATION_SUCCESS_MESSAGE:
      'Notification non enregistrée avec succès',
    NOTIFICATION_UNREGISTRATION_FAILED_MESSAGE:
      'Échec de la désinscription de la notification',
    LOW_STR: 'Bas',
    MEDIUM_STR: 'Moyen',
    HIGH_STR: 'Haut',
    CRITICAL_STR: 'Critique',
    ADD_BUTTON: 'AJOUTER',
    ADD_NEW_PROFILE: 'Ajouter un nouveau profil',
    CONFIRM_MESSAGE: 'Êtes-vous sûr de vouloir supprimer ce profil ?',
    IMMEDIATE_STR: 'Immédiat',
    DAILY_STR: 'Quotidien',
    WEEKLY_STR: 'Hebdomadaire',
    MONTHLY_STR: 'Mensuel',
    SELECT_FREQUENCY: 'Sélectionnez la fréquence: ',
    SCHEDULE_TIME_STR: 'Horaire: ',
    SUNDAY: 'Dimanche',
    MONDAY: 'Lundi',
    TUESDAY: 'Mardi',
    WEDNESDAY: 'Mercredi',
    THURSDAY: 'Jeudi',
    FRIDAY: 'Vendredi',
    SATURDAY: 'Samedi',
    SELECT_WEEK_DAY_STR: 'Sélectionnez le jour de la semaine',
    SELECT_MONTH_DAY_STR: 'Sélectionnez le jour du mois',
    MONTH_DAY_TOOLTIP:
      'Remarque : Si le jour sélectionné dépasse la durée du mois, les notifications seront envoyées le dernier jour du mois.',
    PAGE_TITLE_HISTORY: 'Histoire',
    CONFIG_CHANGE_REQUEST_HISTORY:
      'Historique des demandes de modification de configuration',
    CONFIG_CHANGE_REQUEST: 'Demande de modification de configuration',
    ID: 'IDENTIFIANT',
    SETTING_CHANGES: 'Modifications des paramètres',
    FEATURE_CHANGES: 'Modifications des fonctionnalités',
    SELECTED_LANES: 'Voies sélectionnées',
    SETTINGS_GROUP: 'Groupe de paramètres',
    FEATURE: 'Fonctionnalité',
    COMMAND: 'Commande',
    LABEL_DATE: 'Date',
    FETCH_ERROR_MESSAGE_NBC: `Une erreur liée au NBC s'est produite`,
    ITEM_CODE_ERROR_LABEL: 'Le code article existe déjà',
    IMPORT_CSV_DATA: 'Importer les données CSV',
    ADD: 'Ajouter des éléments au profil existant',
    OVERWRITE: 'Écraser le profil existant',
    LAST_UPDATED: 'Dernière mise à jour',
    SELECT_NBC_IMPORT_METHOD:
      "Veuillez sélectionner la méthode d'importation des éléments NBC :",
    IMPORT_BUTTON: 'Importer',
    CSV_IMPORT_TO_DB_ERROR_MESSAGE:
      "Une erreur s'est produite lors de l'importation des données CSV dans la base de données. Consultez les traces pour plus de détails.",
    UNABLE_TO_LOCATE_WEIGHT_REF_FOLDER_PATH:
      'Impossible de localiser le chemin du dossier des poids de référence. Consultez les traces pour plus de détails.',
    CURRENT_REFERENCE_WEIGHTS: 'Fichier CSV actuel',
    NO_FILE_UPLOADED: 'Aucun fichier téléchargé',
    COMMANDS_HISTORY_LABEL:
      'Historique des commandes : Réinitialiser tous les poids par défaut',
    START_DATE_RANGE_LABEL: 'Date de début: ',
    END_DATE_RANGE_LABEL: 'Date de fin: ',
    FREQUENCY_LABEL: 'Fréquence: ',
    CLOSE_COMMAND_MESSAGE: 'Commande fermée avec succès',
    FAILED_TO_FETCH_COMMANDS: 'Échec de la récupération des commandes',
    CLOSE_ON_TITLE: 'Date fermée',
    MESSAGE_TITLE: 'Message',
    CLOSE_BUTTON: 'Fermer',
    SELECT_IMAGE: "Sélectionner l'image",
    IMPORT_IMAGE: 'Importer images',
    IMPORT_MESSAGE: 'Importation réussie',
    ADDED_NBC_ITEM_MESSAGE: 'Nouvel article NBC ajouté',
    UPDATE_NBC_ITEM_MESSAGE: 'Article NBC mis à jour',
    APPLY_SNAPSHOT_MODAL_MSG:
      "Ce groupe d'articles NBC sera appliqué à toutes les caisses associées au profil",
    APPLY_SNAPSHOT_CONFIRM_MSG: 'Voulez-vous continuer?',
    ERROR_IMPORT_IMAGE: "Format d'image invalide",
    ACCESS_CONTROL: "Contrôle d'accès",
    SELECT_CURRENT_ISSUE: 'Sélectionnez le problème actuel:',
    DECOMMISSION_NODE: 'Désactiver',
    REACTIVATE_NODE: 'Réactiver',
    NODE_UPDATE_TITLE: 'Mise à jour de la caisse',
    DECOMMISSION_CONFIRMATION_MESSAGE:
      'Veuillez confirmer que vous souhaitez désactiver cette caisse:',
    REACTIVATE_CONFIRMATION_MESSAGE:
      'Veuillez confirmer que vous souhaitez réactiver cette caisse:',
    SELECT_REPORTS_FILTER: 'Sélectionner le filtre des rapports:',
    SELECT_REPORT_NAME: 'Sélectionnez le nom du rapport:',
    SEND_CSV_TO_LANE: 'Envoyer CSV à la/les voie(s)',
    CONFIG_ACCESS_CONTROL: 'Configurer le contrôle d’accès',
    STORE_NUMBERS: 'Numéros de magasin',
    ACCESS_RIGHTS: 'Droits d’accès',
    BARCODE_EXPIRY: 'Expiration du code-barres',
    PASSWORD_EXPIRY: 'Expiration du mot de passe',
    SEND_ACCESS_CONTROL_CSV_TO: "Envoyer le fichier CSV de contrôle d'accès à:",
    IMPORT_CSV_LABEL: 'Importer le fichier CSV ici:',
    DELETE_EXISTING_USER_LABEL: 'Supprimer les utilisateurs existants?',
    PASSWORD_EXPIRE_LABEL: 'Les mots de passe expirent?',
    BARCODE_EXPIRE_LABEL: 'Les codes-barres expirent?',
    NOTIFICATION_SUCCESSFULLY_DELETED_CONFIRMATION_MESSAGE:
      'Supprimé avec succès',
    CONFIRM_DELETE_MESSAGE: 'Êtes-vous sûr de vouloir supprimer ces articles?',
    DELETE_ITEM_BUTTON: 'Supprimer les éléments',
    PAGE_TITLE_USERS: 'Utilisateurs',
    ACCESS_CONTROL_HISTORY: "Historique du contrôle d'accès",
    APPLY_NOW: 'Appliquer [Maintenant]',
    APPLY_SCHEDULE: 'Appliquer [Horaire]',
    SNAPSHOT_SCHEDULED:
      "Veuillez sélectionner l'horaire pour appliquer ces articles NBC",
    SET_SCHEDULE: 'Horaire',
    INVALID_DATE_SCHEDULE: 'Date invalide',
    APPLY_CHANGES_CONFIRMATION_MESSAGE:
      'Veuillez sélectionner quand vous souhaitez appliquer ce changement:',
    AGE_DAYS: 'Âge (jours)',
    PAGE_TITLE_DRILLDOWN: 'Exploration hiérarchique NBC',
    CREATE_DRILLDOWN_BUTTON: 'Créer une exploration',
    LABEL_IS_ENABLED: 'Est activé',
    LABEL_IS_VISIBLE: 'Est visible',
    ADD_DRILLDOWN_BUTTON: 'Ajouter un niveau',
    DELETE_DRILLDOWN_BUTTON: 'Supprimer ce niveau',
    ADD_FIRMWARE_FILE_SUCCESS_MESSAGE:
      'Nouveau(x) fichier(s) de micrologiciel téléchargé(s) avec succès',
    ADD_FIRMWARE_FILE_FAILED_MESSAGE:
      "Échec de l'ajout du nouveau fichier de micrologiciel",
    UPDATE_FIRMWARE_FILE_SUCCESS_MESSAGE:
      'Le fichier du micrologiciel a été mis à jour avec succès',
    UPDATE_FIRMWARE_FILE_FAILED_MESSAGE:
      'Échec de la mise à jour (le fichier du micrologiciel existe peut-être déjà)',
    DELETE_FIRMWARE_FILE_SUCCESS_MESSAGE:
      'Le fichier du micrologiciel a été supprimé avec succès',
    DELETE_FIRMWARE_FILE_FAILED_MESSAGE:
      'Échec de la suppression du fichier du micrologiciel',
    ADD_ITEM_TO_DRILLDOWN_BUTTON: "Ajouter un élément à l'exploration",
    EDIT_BUTTON: 'Modifier',
    COLUMN_TITLE_DEPARTMENT: 'Département',
    COLUMN_TITLE_PLU: 'UGS',
    NOTIFICATION_MESSAGE:
      'Tous les articles existent déjà ; aucun nouvel article n’a été ajouté',
    NBC_REQUEST_HISTORY: 'Historique des demandes NBC',
    EDIT_DRILLDOWN: 'Modifier le drilldown',
    TIME_STR: 'Temps:',
    ADD_NEW_STR: 'Ajouter un nouveau',
    SEND_SCHEDULE_LOGS_STR: 'Envoyer une demande à caisses',
    REMOVE_STR: 'Supprimer',
    INVALID_DIRECTORY_PATH: 'Chemin de dossier invalide',
    CANCEL_REQUEST: 'Annuler la demande',
    CANCEL_ALL_REQUESTS: 'Annuler toutes les demandes',
    LOG_FILES_STR: 'Fichiers traces:',
    SEND_REQUEST_STR: 'Envoyer la demande',
    DRILLDOWN_SNAPSHOT_MODAL_TITLE: 'Appliquer l’instantané de drilldown',
    SHOWING_ITEMS: 'Affichage: ',
    MANAGE_GROUPS: 'Gérer les groupes',
    ADD_NEW_GROUP: 'Ajouter un nouveau groupe',
    GROUP_NAME: 'Nom du groupe',
    GROUP_ERROR_MSG: 'Le groupe existe déjà',
    CONFIRM_DELETE_MESAGE: 'Êtes-vous sûr de vouloir supprimer ce groupe ?',
    NOT_SET_STR: 'Non défini',
    EDIT_ITEM: 'Modifier l’article',
    START_DATE_TIME_COLUMN: 'Date de début Heure',
    END_DATE_TIME_COLUMN: 'Date de fin Heure',
    FILE_PATH: 'Chemin du fichier',
    REPORT_ID: 'ID du rapport',
    VIEW_REPORT_STATUS: "Afficher l'historique des exportations",
    REPORT_EXPORTS: 'Exportations de rapports',
    PAGE_TITLE_SCHEDULED_IMPORTS: 'Importations Planifiées',
    SCHEDULED_ALERTS_HEADER: `Planifier l'importation périodique de la base de données des poids`,
    SCHEDULED_ALERTS_HISTORY: `Historique des demandes d'importation de base de données de poids planifiée`,
    ACCESS_CONTROL_PATH: 'Chemin du contrôle d’accès',
    SCHEDULED_ACCESS_CONTROL_HEADER:
      'Planifier l’importation périodique de la base de données du contrôle d’accès',
    SCHEDULED_ACCESS_CONTROL_HISTORY:
      'Historique des demandes d’importation planifiée de la base de données du contrôle d’accès',
    PAGE_TITLE_SCHEDULED_ACCESS_CONTROL:
      'Planifier l’importation du contrôle d’accès',
    STORES_COUNT: 'Magasins (Nombre)',
    LANES_COUNT: 'Voies (Nombre)',
    FILE_SIZE: 'Taille du fichier',
    FILE: 'Fichier',
    DOWNLOAD: 'Télécharger',
    INVALID_DOWNLOAD_URL: 'Lien de téléchargement invalide ou expiré.',
    NO_MENU_ACCESS:
      "Accès refusé. Vous vous êtes authentifié avec succès, mais votre compte n'a pas la permission d'accéder à cette application. Veuillez contacter votre administrateur.",
    EDIT_BOUNDING_BOXES: 'Modifier les zones de délimitation',
    DELETE_SELECTED_BOX: 'Supprimer la zone sélectionnée',
    BOUNDING_BOX_AREAS: 'Zones de délimitation',
    BOUNDING_BOX_AREA_DESC:
      'Sélectionnez une zone, puis dessinez un rectangle sur l’image. Les zones existantes peuvent être déplacées ou redimensionnées.',
    BOUNDING_BOX_OVERLAPS: 'est en chevauchement avec',
    EDIT_BOUNDING_BOX_MESSAGE:
      'Modifiez depuis la vue de configuration de la voie',
    IMPORT_PRODUCT_PACKAGES_TITLE: 'Importer de nouveaux packages produits',
    VALIDATION_IN_PROGRESS: 'Validation en cours',
    VALIDATION_FAILED: 'Échec de la validation',
    UPLOAD_ARTIFACTS_CONFIRM_MESSAGE:
      'Voulez-vous téléverser les artefacts sélectionnés ?',
    FILES_UPLOAD_LIST_MESSAGE: 'Fichiers à téléverser :',
    NO_FILES_TO_UPLOAD_MESSAGE:
      'Les artefacts sélectionnés ont déjà été téléversés. Aucun nouveau fichier à téléverser.',
    ACTIVATION_SUCCESS_MESSAGE: 'Package activé avec succès',
    ACTIVATION_FAILED_MESSAGE: "Échec de l'activation du package",
    COLUMN_TITLE_PACKAGE_NAME: 'Nom du package',
    COLUMN_TITLE_CURRENT_VERSION: 'Version actuelle',
    COLUMN_TITLE_AVAILABLE_VERSIONS: 'Versions disponibles',
    COLUMN_TITLE_FAILURE_MESSAGE: 'Message d’échec',
    COLUMN_TITLE_PRODUCTS_HEALTH: 'État des produits',
    ACTIVATE: 'Activer',
    UPLOADING_STATUS: 'Téléversement en cours',
    COMPLETED_STATUS: 'Terminé',
    FAILED_STATUS: 'Échec',
    VALIDATION_TITLE: 'Validation',
    PLEASE_WAIT: 'Veuillez patienter',
    HEALTHY: 'En bonne santé',
    PRODUCT_PACKAGES: 'Packages de produits',
    IMPORTED_PACKAGES: 'Packages importés',
    IMPORT_COMPLETED: 'Importation terminée',
    IMPORT_COMPLETED_WITH_ERRORS: 'Importation terminée (avec des erreurs)',
    IMPORT_FAILED: "Échec de l'importation",
    IMPORTING_BATCH: 'Importation par lots',
    OF: 'de',
    COMPLETE: 'Complète',
  },
};

export default StringResources;
